function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire37b7"];
parcelRequire.register("6nFQr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "loginPageId", function () { return $3888378b2ea3cea6$export$bb0bd0af2c24d0c1; });
$parcel$export(module.exports, "LoginPageWithPreloadedState", function () { return $3888378b2ea3cea6$export$3cbf98c89d42592c; });
$parcel$export(module.exports, "default", function () { return $3888378b2ea3cea6$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $8KhCJ = parcelRequire("8KhCJ");

var $5lFna = parcelRequire("5lFna");

var $dBq8m = parcelRequire("dBq8m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $6d87w = parcelRequire("6d87w");

var $21Xgy = parcelRequire("21Xgy");

var $1SKGt = parcelRequire("1SKGt");

var $k8MAo = parcelRequire("k8MAo");

var $cRW6P = parcelRequire("cRW6P");

var $8Bf3D = parcelRequire("8Bf3D");

var $64QTD = parcelRequire("64QTD");

var $1rFqe = parcelRequire("1rFqe");

var $bE8z6 = parcelRequire("bE8z6");

var $86qn0 = parcelRequire("86qn0");

var $gKURT = parcelRequire("gKURT");

var $j7UeI = parcelRequire("j7UeI");

var $gs2u7 = parcelRequire("gs2u7");

var $jy3ZD = parcelRequire("jy3ZD");

var $gtKO2 = parcelRequire("gtKO2");

var $1V2cH = parcelRequire("1V2cH");

var $fYxRW = parcelRequire("fYxRW");

var $8Ka53 = parcelRequire("8Ka53");
parcelRequire("0wXBc");
var $iiGfm = parcelRequire("iiGfm");

var $7eeh4 = parcelRequire("7eeh4");

var $ccxRw = parcelRequire("ccxRw");

var $7JGKf = parcelRequire("7JGKf");

var $90cOu = parcelRequire("90cOu");

var $2aGBJ = parcelRequire("2aGBJ");

var $g6OTd = parcelRequire("g6OTd");

var $89bua = parcelRequire("89bua");

var $6e88g = parcelRequire("6e88g");

var $gz8Vs = parcelRequire("gz8Vs");

var $9OWP7 = parcelRequire("9OWP7");

var $3uRS0 = parcelRequire("3uRS0");
let $3888378b2ea3cea6$var$_ = (t)=>t, $3888378b2ea3cea6$var$t;
const $3888378b2ea3cea6$export$bb0bd0af2c24d0c1 = "loginScreen";
const $3888378b2ea3cea6$var$RecaptchaNoticeContainer = (0, $89bua.default).div($3888378b2ea3cea6$var$t || ($3888378b2ea3cea6$var$t = $3888378b2ea3cea6$var$_`
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $3888378b2ea3cea6$var$LoginPage = ()=>(0, $3uRS0.default)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3888378b2ea3cea6$var$LoginPageWithFetchedState, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3888378b2ea3cea6$export$3cbf98c89d42592c, null);
const $3888378b2ea3cea6$var$LoginPageWithFetchedState = ()=>{
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $gz8Vs.usePageState)("/login/state");
    if (isError) throw error;
    return isLoading || !stateFromApi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9OWP7.default), {
        label: "loading"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3888378b2ea3cea6$var$LoginPageComponent, stateFromApi);
};
const $3888378b2ea3cea6$export$3cbf98c89d42592c = ()=>{
    const preloadedState = {
        appConfig: (0, $2aGBJ.useAppSelector)((state)=>state.appConfig),
        csrfToken: (0, $2aGBJ.useAppSelector)((state)=>state.csrfToken),
        cobranding: (0, $2aGBJ.useAppSelector)((state)=>state.cobranding),
        hashedCsrfToken: (0, $2aGBJ.useAppSelector)((state)=>state.hashedCsrfToken),
        login: (0, $2aGBJ.useAppSelector)((state)=>state.login),
        oidcContext: (0, $2aGBJ.useAppSelector)((state)=>state.microbranding.oidcContext)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3888378b2ea3cea6$var$LoginPageComponent, preloadedState);
};
const $3888378b2ea3cea6$var$LoginPageComponent = ({ appConfig: { googleAuthClientId: googleAuthClientId, auth0Config: auth0Config, recaptchaEnable: isCaptchaEnabledByConfig, recaptchaEnterpriseCheckboxKeySite: recaptchaEnterpriseCheckboxKeySite }, hashedCsrfToken: hashedCsrfToken, cobranding: cobranding, csrfToken: csrfToken, login: login, oidcContext: oidcContext })=>{
    hashedCsrfToken = hashedCsrfToken || "TODO: Set for SAS fetch state api flow";
    csrfToken = csrfToken || "TODO: Set for SAS fetch state api flow";
    const dispatch = (0, $2aGBJ.useAppDispatch)();
    const applicationData = (0, $91i6m.useMemo)(()=>(0, $fYxRW.lookupApplication)(cobranding), [
        cobranding
    ]);
    const { isCaptchaRequired: isCaptchaRequired, isCheckingUsername: isCheckingUsername, isErrorShown: isErrorShown, isLoggingIn: isLoggingIn, isUsernameChecked: isUsernameChecked, passwordless: passwordless, nextAttempt: nextAttempt, redirectUrl: redirectUrl, redirectType: redirectType, restrictedEmail: restrictedEmail, usernameExists: usernameExists, identities: identities, fieldErrors: fieldErrors } = (0, $2aGBJ.useAppSelector)((state)=>state.login);
    const { isAnyMobile: isAnyMobile, isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $2aGBJ.useAppSelector)((state)=>state.microbranding);
    const { dismissed: googleOneTapDismissed } = (0, $2aGBJ.useAppSelector)((state)=>state.googleOneTap);
    const { config: marketingConsentConfig } = (0, $2aGBJ.useAppSelector)((state)=>state.marketingConsent);
    const application = applicationData === null || applicationData === void 0 ? void 0 : applicationData.application;
    const isLoading = isCheckingUsername || isLoggingIn;
    const isLoginSecondStep = isUsernameChecked;
    const isPasswordlessAllowed = passwordless !== (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed && !(0, $7eeh4.isMobileOidc)(oidcContext);
    const navigate = (0, $6d87w.useNavigate)();
    const location = (0, $6d87w.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const loginHint = (0, $jy3ZD.useLoginHint)();
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const errorCode = (0, $91i6m.useMemo)(()=>queryParams.errorCode ? {
            code: queryParams.errorCode
        } : null, [
        queryParams.errorCode
    ]);
    const dispatchCaptchaFailure = (0, $91i6m.useCallback)(()=>{
        dispatch((0, $k8MAo.checkUsernameCaptchaFailure)(navigator.onLine));
    }, [
        dispatch
    ]);
    (0, $iiGfm.useRecaptchaChallengeObserver)($3888378b2ea3cea6$export$bb0bd0af2c24d0c1);
    const infoCode = (0, $91i6m.useMemo)(()=>queryParams.infoCode ? {
            code: queryParams.infoCode
        } : null, [
        queryParams.infoCode
    ]);
    const [email, setEmail] = (0, $91i6m.useState)(()=>(0, $jy3ZD.getEmailFromLoginHint)(loginHint) || queryParams.email || "");
    // Check which social login options are being shown
    const isMicrosoftButtonEnabled = (0, $ccxRw.isMicrosoftAuthEnabled)(location);
    const isAppleButtonEnabled = (0, $ccxRw.isAppleAuthEnabled)(location);
    const isSlackButtonEnabled = (0, $ccxRw.isSlackAuthEnabled)(location);
    const appendReasonViewingScreen = (0, $91i6m.useCallback)((eventAttributes)=>{
        if (infoCode) switch(infoCode.code){
            case "migratingExistingUser":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "migratingUser"
                };
            case "existingUserSignupAttempt":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "existingUserSignupAttempt"
                };
            case "invitedUser":
                return {
                    ...eventAttributes,
                    reasonViewingScreen: "invitedUser"
                };
            default:
                return eventAttributes;
        }
        return eventAttributes;
    }, [
        infoCode
    ]);
    (0, $1V2cH.usePageViewedEvent)($3888378b2ea3cea6$export$bb0bd0af2c24d0c1, {
        ...(0, $1V2cH.appendReferer)(appendReasonViewingScreen({
            isMicrosoftButtonEnabled: isMicrosoftButtonEnabled,
            isAppleButtonEnabled: isAppleButtonEnabled,
            isSlackButtonEnabled: isSlackButtonEnabled
        })),
        noAccess: !!queryParams.tenant
    });
    (0, $1V2cH.useOperationalEvent)({
        page: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
        action: "loadLoginPageSuccessful",
        subject: "sli"
    });
    const loginRecoveryOptions = (0, $91i6m.useCallback)(()=>{
        return login.recoveryToken && email ? {
            expectedEmail: email,
            recoveryToken: login.recoveryToken
        } : undefined;
    }, [
        email,
        login.recoveryToken
    ]);
    const handleContinue = (0, $91i6m.useCallback)((username, challengeResponse)=>{
        var _loginRecoveryOptions;
        const query = {
            ...queryParams,
            email: username
        };
        delete query.errorCode;
        navigate(`/login?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(query)}${location.hash}`);
        analyticsClient.formSubmittedEvent($3888378b2ea3cea6$export$bb0bd0af2c24d0c1, "checkUsername", {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type
        });
        dispatch((0, $k8MAo.checkUsername)({
            analyticsClient: analyticsClient,
            username: username,
            params: location.search,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions()) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $cRW6P.fetchConsentConfig)(username));
    }, [
        analyticsClient,
        dispatch,
        navigate,
        location.hash,
        location.search,
        loginRecoveryOptions,
        queryParams
    ]);
    const socialLoginEligibility = (0, $91i6m.useMemo)(()=>(0, $7JGKf.getSocialLoginEligibility)(identities, location, application), [
        application,
        identities,
        location
    ]);
    const { highlightedSocialProvider: highlightedSocialProvider, isEligibleForSocialLogin: isEligibleForSocialLogin } = socialLoginEligibility;
    const showSocialLogin = isLoginSecondStep && isEligibleForSocialLogin;
    (0, $91i6m.useEffect)(()=>{
        if (!isLoading && isLoginSecondStep && usernameExists && identities) analyticsClient.trackingEvent({
            page: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
            action: "triggered",
            subject: "loginSecondStep",
            attributes: {
                eligibility: socialLoginEligibility
            }
        });
    }, [
        analyticsClient,
        identities,
        isLoading,
        isLoginSecondStep,
        socialLoginEligibility,
        usernameExists
    ]);
    (0, $91i6m.useEffect)(()=>{
        const shouldRedirect = !isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect);
        if (redirectUrl) window.location.assign(redirectUrl);
        else if (!isLoading && isUsernameChecked && !usernameExists && shouldRedirect) {
            dispatch((0, $k8MAo.resetLoginForm)());
            analyticsClient.operationalEvent({
                page: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
                subject: "loginAttempt",
                action: "redirectedToSignup"
            });
            if (location.search.length === 0) navigate("/signup?redirectedFrom=login");
            else navigate(`/signup${location.search}&redirectedFrom=login`);
        }
    }, [
        analyticsClient,
        application,
        dispatch,
        navigate,
        isAnyMobile,
        isLoading,
        isMobileApp,
        isUsernameChecked,
        oidcContext,
        redirectUrl,
        usernameExists,
        location.search
    ]);
    const socialButtonClickedEvent = (0, $91i6m.useCallback)((socialProvider)=>{
        analyticsClient.buttonClickedEvent(showSocialLogin ? "socialLoginForm" : $3888378b2ea3cea6$export$bb0bd0af2c24d0c1, `${socialProvider}LoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        showSocialLogin
    ]);
    const handleGoogleSocialLogin = (0, $91i6m.useCallback)(()=>{
        socialButtonClickedEvent((0, $gtKO2.SocialProvider).Google);
        (0, $ccxRw.redirectToGoogleLogin)({
            location: window.location,
            source: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
            recoveryOptions: loginRecoveryOptions()
        });
    }, [
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleAuth0SocialLogin = (0, $91i6m.useCallback)((socialProvider, redirectFn)=>{
        socialButtonClickedEvent(socialProvider);
        redirectFn({
            location: window.location,
            auth0Config: auth0Config,
            // TS typechecking is dumb here - should be quite temporary
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            csrfToken: csrfToken,
            source: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
            email: email || undefined,
            recoveryOptions: loginRecoveryOptions()
        });
    }, [
        auth0Config,
        csrfToken,
        email,
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Microsoft, (0, $ccxRw.redirectToMicrosoftLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Apple, (0, $ccxRw.redirectToAppleLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>handleAuth0SocialLogin((0, $gtKO2.SocialProvider).Slack, (0, $ccxRw.redirectToSlackLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleLogIn = (0, $91i6m.useCallback)((username, password, captchaValue, marketingConsent)=>{
        analyticsClient.formSubmittedEvent($3888378b2ea3cea6$export$bb0bd0af2c24d0c1, "loginForm", appendReasonViewingScreen({
            marketingConsent: (0, $5lFna.dangerouslyCreateSafeString)(marketingConsent.state)
        }));
        const onLoginError = (code)=>{
            analyticsClient.trackingEvent({
                page: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
                action: "submitted",
                subject: "credentials",
                attributes: {
                    successfulAuthentication: false,
                    errorCode: code
                }
            });
        };
        dispatch((0, $k8MAo.loginUsernamePassword)({
            username: username,
            password: password,
            captchaValue: captchaValue,
            location: window.location,
            onLoginError: onLoginError,
            marketingConsent: marketingConsent
        }));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        dispatch
    ]);
    const handlePasswordlessLogIn = (0, $91i6m.useCallback)(async (email, captchaValue)=>{
        const { success: success } = await dispatch((0, $k8MAo.loginPasswordless)({
            email: email,
            captchaValue: captchaValue,
            location: window.location
        }));
        if (success) dispatch((0, $21Xgy.addFlag)("success", (0, $90cOu.LoginPageMessages).passwordlessSuccessTitle, (0, $90cOu.LoginPageMessages).passwordlessSuccessDescription));
    }, [
        dispatch
    ]);
    const handleEditEmail = (0, $91i6m.useCallback)(()=>dispatch((0, $k8MAo.resetLoginForm)()), [
        dispatch
    ]);
    const handleValidationError = (0, $91i6m.useCallback)((errors)=>dispatch((0, $k8MAo.showFormErrors)(errors)), [
        dispatch
    ]);
    const onDismissGoogleOneTap = (0, $91i6m.useCallback)(()=>dispatch((0, $1SKGt.dismissGoogleOneTap)()), [
        dispatch
    ]);
    const handleFormClick = (0, $91i6m.useCallback)(()=>{
        if (screenSize === "mobile") onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize
    ]);
    const handleEmailChange = (0, $91i6m.useCallback)((email)=>{
        setEmail(email);
    }, []);
    const signupLinkEnabled = (0, $91i6m.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = !isMobileApp || (0, $7eeh4.isOidcDisplayMode)(oidcContext, (0, $gtKO2.OidcDisplay).LoginWithRedirect);
        return queryParams.shide !== "true" && shouldRenderSignupLink;
    }, [
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    const getSignupLinkElement = ()=>{
        if (signupLinkEnabled) {
            const elementText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), (0, $90cOu.LoginPageMessages).createAnAccount);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6d87w.Link), {
                to: "/signup" + location.search,
                id: "signup",
                className: "primary-action",
                onClick: ()=>{
                    analyticsClient.linkClickedEvent($3888378b2ea3cea6$export$bb0bd0af2c24d0c1, "signUpLink");
                }
            }, elementText);
        }
        return null;
    };
    const buildHeader = ()=>{
        if (showSocialLogin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            tagName: "h5",
            ...(0, $90cOu.LoginPageMessages).socialFormTitle,
            values: {
                socialProviderName: highlightedSocialProvider === null || highlightedSocialProvider === void 0 ? void 0 : highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            tagName: "h5",
            ...(0, $90cOu.LoginPageMessages).headTitle
        });
    };
    const buildFooter = ()=>{
        return isEmbedded ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("ul", {
            className: "fine-print"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $bE8z6.PrivacyPolicyLink), {
            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8Bf3D.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $bE8z6.UserNoticeLink), {
            isMobileLink: (0, $7eeh4.isMobileOidc)(oidcContext)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($3888378b2ea3cea6$var$RecaptchaNoticeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $g6OTd.RecaptchaNotice), null)));
    };
    const buildWhiteboxFooter = (resetPasswordLink)=>{
        const signupLink = getSignupLinkElement();
        if (showSocialLogin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $64QTD.default), {
            id: "use-a-different-login-method",
            spacing: "none",
            onClick: ()=>{
                dispatch((0, $k8MAo.resetLoginForm)());
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), (0, $90cOu.LoginPageMessages).socialFormUseDifferentLoginMethod));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6d87w.Link), {
            to: resetPasswordLink,
            id: "resetPassword"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "trouble.logging.in",
            defaultMessage: "Can't log in?"
        }))), signupLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8Bf3D.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("li", null, signupLink)));
    };
    const renderSocialLoginPanel = ()=>{
        const SocialLogin = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $j7UeI.default), {
            handleGoogleLogin: handleGoogleSocialLogin,
            handleMicrosoftLogin: handleMicrosoftLogin,
            handleAppleLogin: handleAppleLogin,
            handleSlackLogin: handleSlackLogin
        });
        return isEmbedded || SocialLogin;
    };
    const resetPasswordLink = "/login/resetpassword" + location.search;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $1rFqe.default), {
        csrfToken: hashedCsrfToken,
        googleAuthClientId: googleAuthClientId,
        source: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
        enabled: !googleOneTapDismissed && (0, $8Ka53.isBooleanFeatureFlagSet)("aid-frontend.google.one.tap.enabled"),
        recoveryOptions: loginRecoveryOptions()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8KhCJ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("title", null, formatMessage((0, $90cOu.LoginPageMessages).headTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gs2u7.default), {
        pageId: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
        header: buildHeader(),
        footer: buildFooter(),
        whiteboxFooter: buildWhiteboxFooter(resetPasswordLink)
    }, showSocialLogin && highlightedSocialProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gKURT.default), {
        email: email,
        highlightedSocialProvider: highlightedSocialProvider,
        handleGoogleLogin: handleGoogleSocialLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $86qn0.default), {
        application: applicationData && applicationData.application,
        isCaptchaEnabledByConfig: isCaptchaEnabledByConfig,
        isCaptchaRequired: isCaptchaRequired,
        isErrorShown: isErrorShown || !!errorCode,
        redirectType: !isLoginSecondStep ? redirectType : null,
        isRedirecting: redirectType !== null,
        isSecondStep: isLoginSecondStep,
        isPasswordlessAllowed: isPasswordlessAllowed,
        isLoading: isLoading,
        nextAttempt: nextAttempt,
        onContinue: handleContinue,
        onLogIn: handleLogIn,
        onPasswordlessLogIn: handlePasswordlessLogIn,
        error: login.error || errorCode,
        info: infoCode,
        fieldErrors: fieldErrors,
        email: email,
        onValidationError: handleValidationError,
        onCaptchaFailure: dispatchCaptchaFailure,
        onEditEmail: handleEditEmail,
        onFormClick: handleFormClick,
        recaptchaEnterpriseCheckboxKeySite: recaptchaEnterpriseCheckboxKeySite,
        resetPasswordLink: resetPasswordLink,
        restrictedEmail: restrictedEmail || queryParams.restrict === "true",
        marketingConsentConfig: marketingConsentConfig,
        pageId: $3888378b2ea3cea6$export$bb0bd0af2c24d0c1,
        onEmailChange: handleEmailChange
    }), renderSocialLoginPanel())));
};
var $3888378b2ea3cea6$export$2e2bcd8739ae039 = $3888378b2ea3cea6$var$LoginPage;

});
parcelRequire.register("1SKGt", function(module, exports) {

$parcel$export(module.exports, "dismissGoogleOneTap", function () { return $d1fead2b0aa97e4d$export$7634a565805a5f09; });
const $d1fead2b0aa97e4d$export$7634a565805a5f09 = ()=>({
        type: "GOOGLE_ONE_TAP_DISMISS"
    });

});

parcelRequire.register("k8MAo", function(module, exports) {

$parcel$export(module.exports, "checkUsernameCaptchaFailure", function () { return $1f9969ad83fb8729$export$c48d28459d63299c; });
$parcel$export(module.exports, "resetLoginForm", function () { return $1f9969ad83fb8729$export$6a45e1ba06bcfd40; });
$parcel$export(module.exports, "showFormErrors", function () { return $1f9969ad83fb8729$export$f89084e6f067bb43; });
$parcel$export(module.exports, "checkUsername", function () { return $1f9969ad83fb8729$export$4929d86c6e4e281e; });
$parcel$export(module.exports, "loginUsernamePassword", function () { return $1f9969ad83fb8729$export$5391cc01902916c6; });
$parcel$export(module.exports, "loginPasswordless", function () { return $1f9969ad83fb8729$export$a6eaf375001ea98a; });

var $dBq8m = parcelRequire("dBq8m");

var $kU6Wu = parcelRequire("kU6Wu");

var $90yWB = parcelRequire("90yWB");

var $49Pnv = parcelRequire("49Pnv");

var $gtKO2 = parcelRequire("gtKO2");

var $fqbXQ = parcelRequire("fqbXQ");

var $6nFQr = parcelRequire("6nFQr");

var $2w6uX = parcelRequire("2w6uX");

var $kfTGh = parcelRequire("kfTGh");

var $hB2TQ = parcelRequire("hB2TQ");

var $4JAG5 = parcelRequire("4JAG5");
const $1f9969ad83fb8729$export$9cdc46fdb2ee9975 = (response)=>response.ok ? response : response.text().then((error)=>{
        throw new Error(error || response.statusText);
    });
const $1f9969ad83fb8729$export$46a04796807ec7cb = ()=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME"
    });
const $1f9969ad83fb8729$export$2edff4284d04f803 = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_REDIRECT",
        redirectUrl: userAction.redirect_uri,
        redirectType: userAction.redirect_type
    });
const $1f9969ad83fb8729$export$5cc9c4683c14face = ()=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_SIGNUP"
    });
const $1f9969ad83fb8729$export$c7d021a470828fad = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION",
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed
    });
const $1f9969ad83fb8729$export$a7eb3c2b6fb70d6e = (userAction)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN",
        passwordless: userAction.passwordless || (0, $gtKO2.CheckUserNamePasswordlessType).Disallowed,
        identities: userAction.identities
    });
const $1f9969ad83fb8729$var$requestCheckUsernameSucceeded = (userAction, analyticsClient)=>(dispatch)=>{
        switch(userAction.action){
            case "redirect":
                dispatch($1f9969ad83fb8729$export$2edff4284d04f803(userAction));
                break;
            case "signup":
                dispatch($1f9969ad83fb8729$export$5cc9c4683c14face());
                break;
            case "no_action":
                dispatch($1f9969ad83fb8729$export$c7d021a470828fad(userAction));
                break;
            case "social_login":
                if (!userAction.identities || userAction.identities.password === undefined) // this event is needed for growth team's experiment slo
                // we want to silently fire this event and not show any error
                // this will just not enrol user in the experiment
                analyticsClient.operationalEvent({
                    page: (0, $6nFQr.loginPageId),
                    action: "loadSocialLoginPage",
                    subject: "sli",
                    attributes: {
                        hasError: true,
                        errorName: "identities not as expected"
                    }
                });
                dispatch($1f9969ad83fb8729$export$a7eb3c2b6fb70d6e(userAction));
                break;
        }
        return Promise.resolve();
    };
const $1f9969ad83fb8729$export$c48d28459d63299c = (isOnline)=>$1f9969ad83fb8729$export$c445752097d9b598({
        code: isOnline ? "captcha" : "request_error"
    });
const $1f9969ad83fb8729$export$9cd96a2b004cc2f1 = (error)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$c445752097d9b598 = (error)=>({
        type: "LOGIN_REQUEST_CHECK_USERNAME_ERROR",
        error: error
    });
const $1f9969ad83fb8729$export$6a45e1ba06bcfd40 = ()=>({
        type: "LOGIN_RESET"
    });
const $1f9969ad83fb8729$export$8a7c7d5c19ae03dc = ()=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN"
    });
const $1f9969ad83fb8729$export$e35197b32bd33011 = ()=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN"
    });
const $1f9969ad83fb8729$export$2195b30ff9688f1f = ()=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS"
    });
const $1f9969ad83fb8729$export$9fbe8d742e3cfe1f = (error)=>({
        type: "LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$8d0d1628cde4bf96 = (redirectUrl = "")=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS",
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$72f5cc903fa26407 = (error)=>({
        type: "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED",
        error: error
    });
const $1f9969ad83fb8729$export$7598c3f25ced4803 = (redirectUrl)=>({
        type: "LOGIN_REDIRECT_USER",
        redirectUrl: redirectUrl
    });
const $1f9969ad83fb8729$export$84085369fb3df1bc = (nextAttempt)=>({
        type: "UPDATE_LOGIN_ATTEMPT_DETAILS",
        nextAttempt: nextAttempt
    });
const $1f9969ad83fb8729$export$3e87c66a234f33b9 = (isCaptchaRequired)=>({
        type: "LOGIN_UPDATE_CAPTCHA_REQUIREMENT",
        isCaptchaRequired: isCaptchaRequired
    });
const $1f9969ad83fb8729$export$f89084e6f067bb43 = (errors)=>({
        type: "LOGIN_SHOW_LOGIN_FORM_ERRORS",
        errors: errors
    });
const $1f9969ad83fb8729$var$usernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($1f9969ad83fb8729$export$46a04796807ec7cb());
        let response;
        try {
            response = await fetch(`/rest/check-username${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    "challenge-response": (0, $4JAG5.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $6nFQr.loginPageId),
                action: "checkUsernameFailure",
                subject: "sli"
            });
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: "request_error"
            }));
            return;
        }
        let analyticsAction;
        if (response.ok) try {
            dispatch($1f9969ad83fb8729$var$requestCheckUsernameSucceeded(await response.json(), analyticsClient));
            analyticsAction = "checkUsernameSuccessful";
        } catch (parseError) {
            dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                code: "unknown"
            }));
            analyticsAction = "checkUsernameFailure";
        }
        else {
            analyticsAction = "checkUsernameFailure";
            let errorText = null;
            try {
                if (response.status === 429) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: "too_many_username_requests"
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                        code: uiErrors[0].key || "unknown"
                    }));
                } else {
                    errorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(errorText).formErrors[0];
                    dispatch($1f9969ad83fb8729$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                (0, $49Pnv.captureErrorMessage)("Username check failed", {
                    statusCode: response.status,
                    errorText: errorText,
                    errorMessage: parseError.message
                });
                dispatch($1f9969ad83fb8729$export$c445752097d9b598({
                    code: "unknown"
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $6nFQr.loginPageId),
            action: analyticsAction,
            subject: "sli"
        });
    };
const $1f9969ad83fb8729$export$4929d86c6e4e281e = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $6nFQr.loginPageId),
            action: "checkUsernameStart",
            subject: "sli"
        });
        return dispatch($1f9969ad83fb8729$var$usernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
function $1f9969ad83fb8729$var$reportFrontendError(error) {
    function removeField(obj, fieldName) {
        for(const prop in obj){
            if (prop === fieldName) delete obj[prop];
            else if (typeof obj[prop] === "object") removeField(obj[prop], fieldName);
        }
    }
    function decodeJsonField(obj, path) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($90yWB)))(obj, path);
        if (val !== "undefined") try {
            (0, (/*@__PURE__*/$parcel$interopDefault($kU6Wu)))(obj, path, JSON.parse(val));
        } catch (_) {}
    }
    removeField(error, "password");
    decodeJsonField(error, "original.response.text");
    const errorCode = error["error"];
    (0, $49Pnv.captureErrorMessage)(errorCode, {
        code: errorCode,
        errorPayload: error
    });
}
function $1f9969ad83fb8729$var$parseAdditionalData(err) {
    try {
        return JSON.parse(atob(err.error_description));
    } catch (e) {
        return {};
    }
}
function $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError) {
    const additionalData = $1f9969ad83fb8729$var$parseAdditionalData(err);
    const code = (additionalData["custom_error"] || err["error"] || "").toLowerCase();
    const isBitbucket = application && application.toLowerCase() === "bitbucket";
    if (code === "too_many_attempts" || code === "invalid_captcha") {
        dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(true));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "captcha"
        }));
    } else if (code === "access_denied") {
        dispatch($1f9969ad83fb8729$export$84085369fb3df1bc(getState().login.nextAttempt + 1));
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "invalid_user_password"
        }));
    } else if (code === "ambiguous_user") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "ambiguous_user"
    }));
    else if (code === "no_email_on_remote_user") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "no_email_on_remote_user",
        args: {
            username: username
        }
    }));
    else if (code === "username_is_not_email") {
        const errorCode = isBitbucket ? "bitbucket_username_is_not_email" : "username_is_not_email";
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData["email"]
            }
        }));
    } else if (code === "email_is_not_primary") {
        const errorCode = isBitbucket ? "bitbucket_email_is_not_primary" : "email_is_not_primary";
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData["email"]
            }
        }));
    } else if (code === "too_many_logins") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "too_many_logins"
    }));
    else if (code === "password_leaked") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "password_leaked"
    }));
    else if (code === "blocked_user") {
        const redirectURL = application ? `/login/inactive?application=${application}` : "/login/inactive";
        dispatch($1f9969ad83fb8729$export$7598c3f25ced4803(redirectURL));
    } else if (code === "request_error") // 'request_error' auth0-js: connection fails due to offline or cross domain issue
    dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "request_error"
    }));
    else if (code === "invalid.session.token") dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
        code: "invalid.session.token"
    }));
    else {
        $1f9969ad83fb8729$var$reportFrontendError(err);
        dispatch($1f9969ad83fb8729$export$72f5cc903fa26407({
            code: "unknown"
        }));
    }
    if (code !== "too_many_attempts" && code !== "invalid_captcha") dispatch($1f9969ad83fb8729$export$3e87c66a234f33b9(false));
    onLoginError(code);
}
function $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username) {
    if (!captchaValue) return Promise.resolve();
    return fetch("/rest/captcha/verify", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "g-recaptcha-response": captchaValue,
            email: username
        })
    }).then($1f9969ad83fb8729$export$9cdc46fdb2ee9975).catch(()=>{
        const errorPayload = {};
        errorPayload["error"] = "invalid_captcha";
        return Promise.reject(errorPayload);
    });
}
const $1f9969ad83fb8729$export$beb986ec1c64324 = (csrfToken, config, marketingConsentState, anonymousId, userFlow)=>{
    let state = {
        csrfToken: csrfToken,
        anonymousId: anonymousId,
        userFlow: userFlow
    };
    const marketingConsent = (0, $fqbXQ.buildMarketingConsent)(config, marketingConsentState);
    if (marketingConsent) state = {
        ...state,
        marketingConsent: marketingConsent
    };
    return state;
};
const $1f9969ad83fb8729$export$5391cc01902916c6 = (loginParams)=>(dispatch, getState)=>{
        const { location: location, username: username, password: password, captchaValue: captchaValue, onLoginError: onLoginError } = loginParams;
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
        const { application: application, userFlow: userFlow } = params;
        const state = getState();
        const { csrfToken: csrfToken, marketingConsent: marketingConsent } = state;
        dispatch($1f9969ad83fb8729$export$8a7c7d5c19ae03dc());
        const loginState = $1f9969ad83fb8729$export$beb986ec1c64324(csrfToken, marketingConsent.config, loginParams.marketingConsent, (0, $2w6uX.getAnonymousId)(), userFlow);
        const loginWithAtlassianAuth = ()=>(0, $kfTGh.login)({
                username: username,
                password: password,
                state: loginState,
                query: `${location.search}${location.hash}`
            }).then((result)=>{
                switch(result.kind){
                    case "failure":
                        const err = {
                            error: result.reason
                        };
                        return $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
                    case "success":
                        return window.location.assign(result.redirectUri);
                }
            });
        return $1f9969ad83fb8729$var$verifyCaptchaIfRequired(captchaValue, username).then(()=>loginWithAtlassianAuth()).catch((err)=>{
            (0, $49Pnv.captureException)(err);
            $1f9969ad83fb8729$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
        });
    };
const $1f9969ad83fb8729$export$a6eaf375001ea98a = ({ email: email, captchaValue: captchaValue, location: location })=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($1f9969ad83fb8729$export$e35197b32bd33011());
        try {
            const response = await fetch(`/rest/login/passwordless${location.search}`, {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": csrfToken,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email,
                    captchaValue: captchaValue
                })
            });
            const { csrfToken: newCsrfToken } = await response.json();
            if (newCsrfToken) dispatch((0, $hB2TQ.updateCsrfToken)(newCsrfToken));
            if (response.ok) {
                dispatch($1f9969ad83fb8729$export$2195b30ff9688f1f());
                return {
                    success: true
                };
            } else {
                dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                    code: "unknown"
                }));
                return {
                    success: false
                };
            }
        } catch (error) {
            (0, $49Pnv.captureErrorMessage)(error.message, error);
            dispatch($1f9969ad83fb8729$export$9fbe8d742e3cfe1f({
                code: "request_error"
            }));
            return {
                success: false
            };
        }
    };

});
parcelRequire.register("kfTGh", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $8630aadc7660b7c8$export$596d806903d1f59e; });

var $dBq8m = parcelRequire("dBq8m");

var $bqdjD = parcelRequire("bqdjD");
var $8630aadc7660b7c8$export$db7ad81c1149bb91;
(function(LoginFailureReason) {
    LoginFailureReason["AccessDenied"] = "access_denied";
    LoginFailureReason["PasswordLeaked"] = "password_leaked";
    LoginFailureReason["BlockedUser"] = "blocked_user";
    LoginFailureReason["TooManyAttempts"] = "too_many_attempts";
    LoginFailureReason["TooManyLogins"] = "too_many_logins";
})($8630aadc7660b7c8$export$db7ad81c1149bb91 || ($8630aadc7660b7c8$export$db7ad81c1149bb91 = {}));
var $8630aadc7660b7c8$export$5e64a9683d127ef6;
(function(LoginError) {
    LoginError["PreconditionFailed"] = "precondition_failed";
    LoginError["UnexpectedError"] = "unexpected_error";
})($8630aadc7660b7c8$export$5e64a9683d127ef6 || ($8630aadc7660b7c8$export$5e64a9683d127ef6 = {}));
function $8630aadc7660b7c8$var$failure(reason) {
    return {
        kind: "failure",
        reason: reason
    };
}
function $8630aadc7660b7c8$var$success(redirectUri) {
    return {
        kind: "success",
        redirectUri: redirectUri
    };
}

async function $8630aadc7660b7c8$export$596d806903d1f59e({ state: state, username: username, password: password, query: query }) {
    const token = (0, $bqdjD.currentPerimeter) !== "commercial" ? null : await (parcelRequire("8PhTi")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>"");
    return fetch(`/rest/authenticate${query}`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            username: username,
            password: password,
            state: state,
            ...token && {
                token: token
            }
        })
    }).then((response)=>{
        switch(response.status){
            case 200:
                return response.json().then((r)=>$8630aadc7660b7c8$var$success(r.redirectUri));
            case 403:
                return response.json().then((r)=>{
                    switch(r.error){
                        case "access_denied":
                            return $8630aadc7660b7c8$var$failure($8630aadc7660b7c8$export$db7ad81c1149bb91.AccessDenied);
                        case "blocked_user":
                            return $8630aadc7660b7c8$var$failure($8630aadc7660b7c8$export$db7ad81c1149bb91.BlockedUser);
                        case "password_leaked":
                            return $8630aadc7660b7c8$var$failure($8630aadc7660b7c8$export$db7ad81c1149bb91.PasswordLeaked);
                        case "too_many_attempts":
                            return $8630aadc7660b7c8$var$failure($8630aadc7660b7c8$export$db7ad81c1149bb91.TooManyAttempts);
                        default:
                            return Promise.reject(new Error($8630aadc7660b7c8$export$5e64a9683d127ef6.UnexpectedError));
                    }
                });
            case 429:
                return response.json().then((r)=>r.error === "too_many_logins" ? $8630aadc7660b7c8$var$failure($8630aadc7660b7c8$export$db7ad81c1149bb91.TooManyLogins) : Promise.reject(new Error($8630aadc7660b7c8$export$5e64a9683d127ef6.UnexpectedError)));
            case 412:
                return response.json().then((r)=>{
                    switch(r.error){
                        case "mfa_required":
                            const currentQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                            currentQueryParams.transactionToken = r.token;
                            const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(currentQueryParams);
                            return $8630aadc7660b7c8$var$success(`/login/mfa?${currentQueryString}`);
                        default:
                            return Promise.reject(new Error($8630aadc7660b7c8$export$5e64a9683d127ef6.PreconditionFailed));
                    }
                });
            default:
                return Promise.reject(new Error($8630aadc7660b7c8$export$5e64a9683d127ef6.UnexpectedError));
        }
    });
}

});
parcelRequire.register("8PhTi", function(module, exports) {

module.exports = import("./" + (parcelRequire("lxKym")).resolve("hQDxa")).then(()=>parcelRequire("7FBZw"));

});


parcelRequire.register("hB2TQ", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $aae4dd533076dc9f$export$527f2c21586e0a0e; });
const $aae4dd533076dc9f$export$527f2c21586e0a0e = (csrfToken)=>({
        type: "CSRF_TOKEN_UPDATE",
        csrfToken: csrfToken
    });

});


parcelRequire.register("8Bf3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8598e8620eefabcf$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");
let $8598e8620eefabcf$var$_ = (t)=>t, $8598e8620eefabcf$var$t;
const $8598e8620eefabcf$var$SeparatorContainer = (0, $89bua.default).p($8598e8620eefabcf$var$t || ($8598e8620eefabcf$var$t = $8598e8620eefabcf$var$_`
  margin: 0px 8px;
`));
const $8598e8620eefabcf$var$Bull = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($8598e8620eefabcf$var$SeparatorContainer, null, "•");
var $8598e8620eefabcf$export$2e2bcd8739ae039 = $8598e8620eefabcf$var$Bull;

});

parcelRequire.register("1rFqe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a17c37a69764cd5$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");

var $ccxRw = parcelRequire("ccxRw");

var $dBq8m = parcelRequire("dBq8m");

var $2w6uX = parcelRequire("2w6uX");

var $g7xf6 = parcelRequire("g7xf6");

var $1V2cH = parcelRequire("1V2cH");

var $bqdjD = parcelRequire("bqdjD");
const $3a17c37a69764cd5$var$oneTapClientUrl = "https://accounts.google.com/gsi/client";
const $3a17c37a69764cd5$export$dc57f6202fda5ffc = ({ children: children, csrfToken: csrfToken, enabled: enabled, google: google, googleAuthClientId: googleAuthClientId, recoveryOptions: recoveryOptions, source: source })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    (0, $91i6m.useEffect)(()=>{
        var _google_accounts;
        const isCommercial = (0, $bqdjD.currentPerimeter) === "commercial";
        if ((google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : _google_accounts.id) && enabled && isCommercial) {
            google.accounts.id.initialize({
                client_id: googleAuthClientId,
                cancel_on_tap_outside: false,
                use_fedcm_for_prompt: true,
                itp_support: false,
                callback: (credentialResponse)=>{
                    analyticsClient.buttonClickedEvent(source, "googleYoloAccountSelected");
                    const { userFlow: userFlow } = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(window.location.search);
                    const callbackBase = `${window.location.origin}/login/google`;
                    const callbackParams = {
                        state: (0, $ccxRw.buildState)({
                            location: window.location,
                            csrfToken: csrfToken,
                            source: source,
                            loginType: (0, $ccxRw.LoginType).GoogleOneTap,
                            anonymousId: (0, $2w6uX.getAnonymousId)(),
                            userFlow: userFlow,
                            recoveryOptions: recoveryOptions
                        })
                    };
                    (0, $g7xf6.default)({
                        method: "POST",
                        action: `${callbackBase}?${(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(callbackParams)}`,
                        payload: {
                            id_token: credentialResponse.credential
                        }
                    });
                }
            });
            google.accounts.id.prompt((notification)=>{
                if (notification.isDismissedMoment()) {
                    const reason = notification.getDismissedReason();
                    analyticsClient.buttonClickedEvent(source, "googleYoloDismissed", {
                        reason: reason
                    });
                }
            });
        }
        return ()=>{
            var _google_accounts, _google_accounts_id;
            return google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : (_google_accounts_id = _google_accounts.id) === null || _google_accounts_id === void 0 ? void 0 : _google_accounts_id.cancel();
        };
    }, [
        google,
        enabled,
        googleAuthClientId,
        csrfToken,
        analyticsClient,
        source,
        recoveryOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, children);
};
var $3a17c37a69764cd5$export$2e2bcd8739ae039 = (0, $8hJHo.default)($3a17c37a69764cd5$var$oneTapClientUrl, {
    globalName: "google",
    attributes: {
        nonce: window.cspNonce
    }
})($3a17c37a69764cd5$export$dc57f6202fda5ffc);

});
parcelRequire.register("8hJHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60835c15747f25e9$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $eYOCy = parcelRequire("eYOCy");

var $kTpRR = parcelRequire("kTpRR");
function $60835c15747f25e9$var$_extends() {
    $60835c15747f25e9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $60835c15747f25e9$var$_extends.apply(this, arguments);
}
function $60835c15747f25e9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $60835c15747f25e9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $60835c15747f25e9$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $60835c15747f25e9$var$idCount = 0;
function $60835c15747f25e9$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $60835c15747f25e9$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $60835c15747f25e9$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $60835c15747f25e9$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($60835c15747f25e9$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $60835c15747f25e9$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $60835c15747f25e9$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $91i6m.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $91i6m.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $91i6m.forwardRef)(function(props, ref) {
            return (0, $91i6m.createElement)(AsyncScriptLoader, $60835c15747f25e9$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($eYOCy))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($kTpRR)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRequire.register("g7xf6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dceb0d2fa4ff3245$export$2e2bcd8739ae039; });
function $dceb0d2fa4ff3245$export$2e2bcd8739ae039({ method: method, action: action = "", payload: payload, skipSanitizationKeys: skipSanitizationKeys = [] }) {
    const form = document.createElement("form");
    form.style.display = "none";
    form.method = method;
    form.action = action;
    if (payload) Object.entries(payload).filter(([, value])=>value != null).forEach(([name, value])=>{
        const input = document.createElement("input");
        input.name = $dceb0d2fa4ff3245$var$sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name) ? String(value) : $dceb0d2fa4ff3245$var$sanitizeInput(String(value));
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */ function $dceb0d2fa4ff3245$var$sanitizeInput(input) {
    const div = document.createElement("div");
    div.textContent = input;
    return div.innerHTML;
}

});


parcelRequire.register("86qn0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5222838829b1b3e4$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");
var $leG06 = parcelRequire("leG06");

var $9OWP7 = parcelRequire("9OWP7");

var $89bua = parcelRequire("89bua");

var $lPSLn = parcelRequire("lPSLn");

var $bt1Sd = parcelRequire("bt1Sd");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $dmC2D = parcelRequire("dmC2D");

var $9w0eB = parcelRequire("9w0eB");

var $lkawQ = parcelRequire("lkawQ");

var $cLysE = parcelRequire("cLysE");

var $g6OTd = parcelRequire("g6OTd");

var $31nHY = parcelRequire("31nHY");

var $lnbpL = parcelRequire("lnbpL");

var $j7UeI = parcelRequire("j7UeI");

var $85UJE = parcelRequire("85UJE");

var $gtKO2 = parcelRequire("gtKO2");

var $fxz8k = parcelRequire("fxz8k");

var $fYxRW = parcelRequire("fYxRW");

var $1V2cH = parcelRequire("1V2cH");

var $bE8z6 = parcelRequire("bE8z6");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");

var $6VPdM = parcelRequire("6VPdM");

var $6d87w = parcelRequire("6d87w");

var $6nFQr = parcelRequire("6nFQr");

var $3yDip = parcelRequire("3yDip");

var $4JAG5 = parcelRequire("4JAG5");
let $5222838829b1b3e4$var$_ = (t)=>t, $5222838829b1b3e4$var$t, $5222838829b1b3e4$var$t1, $5222838829b1b3e4$var$t2, $5222838829b1b3e4$var$t3;
const $5222838829b1b3e4$export$d55ce944e082b58f = (0, $89bua.default).div($5222838829b1b3e4$var$t || ($5222838829b1b3e4$var$t = $5222838829b1b3e4$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kLNLK).N90);
const $5222838829b1b3e4$export$a7fed597f4b8afd8 = (0, $89bua.default).form($5222838829b1b3e4$var$t1 || ($5222838829b1b3e4$var$t1 = $5222838829b1b3e4$var$_`
  margin: 0;
`));
const $5222838829b1b3e4$var$InputsWrapper = (0, $89bua.default).div($5222838829b1b3e4$var$t2 || ($5222838829b1b3e4$var$t2 = $5222838829b1b3e4$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)());
const $5222838829b1b3e4$var$StyledMarketingConsent = (0, $89bua.default)((0, $fxz8k.default))($5222838829b1b3e4$var$t3 || ($5222838829b1b3e4$var$t3 = $5222838829b1b3e4$var$_`
  padding-top: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $5222838829b1b3e4$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isCaptchaEnabledByConfig: isCaptchaEnabledByConfig, isCaptchaRequired: isCaptchaRequired, isErrorShown: isErrorShown, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, marketingConsentConfig: marketingConsentConfig, nextAttempt: nextAttempt, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, onCaptchaFailure: onCaptchaFailure, pageId: pageId, recaptchaEnterpriseCheckboxKeySite: recaptchaEnterpriseCheckboxKeySite, redirectType: redirectType, resetPasswordLink: resetPasswordLink, restrictedEmail: restrictedEmail })=>{
    const intl = (0, $leG06.default)();
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const [password, setPassword] = (0, $91i6m.useState)("");
    const [captchaValue, setCaptchaValue] = (0, $91i6m.useState)(null);
    const [marketingConsent, setMarketingConsent] = (0, $91i6m.useState)({
        state: "not_shown"
    });
    const [isCheckUsernameCaptchaLoading, setIsCheckUsernameCaptchaLoading] = (0, $91i6m.useState)(false);
    const [buttonClicked, setButtonClicked] = (0, $91i6m.useState)("submit");
    const inputRef = (0, $91i6m.useRef)(null);
    const [searchParams] = (0, $6d87w.useSearchParams)();
    const isCheckUsernameRecaptchaEnabled = (0, $4JAG5.isCheckUsernameRecaptchaEnabledFF)();
    const recaptchaType = (error === null || error === void 0 ? void 0 : error.code) === "captchaScoreTooLow" ? "checkbox" : "score";
    const recaptcha = (0, $6VPdM.useRecaptcha)({
        pageId: pageId,
        type: recaptchaType,
        enabledProp: isCheckUsernameRecaptchaEnabled,
        action: "checkUsername"
    });
    const restrict = searchParams.get("restrict") === "true";
    const fetchRecaptchaTokenAndSubmitContinue = async (email)=>{
        try {
            setIsCheckUsernameCaptchaLoading(true);
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).start();
            const challengeResponse = await recaptcha.fetchToken("checkUsername");
            (0, $3yDip.recaptchaCheckUsernameFetchTokenInteraction).stop({
                customData: {
                    restrict: restrict
                }
            });
            onContinue(email, challengeResponse);
        } catch (error) {
            analyticsClient.errorShownEvent((0, $6nFQr.loginPageId), "recaptchaError", {
                errorMessage: error.message
            });
            onCaptchaFailure();
        } finally{
            setIsCheckUsernameCaptchaLoading(false);
        }
    };
    // This code is intended to auto-submit the check-username request if `restrict=true`
    (0, $91i6m.useEffect)(()=>{
        const handleMount = async ()=>{
            const emailWithDefault = email || "";
            if (!restrict || !emailWithDefault) return;
            if (!isCheckUsernameRecaptchaEnabled) {
                onContinue(emailWithDefault, null);
                return;
            }
            // we don't want to show the spinner if checkbox recaptcha is loading for the time being
            if (recaptchaType === "score") setIsCheckUsernameCaptchaLoading(true);
            if (recaptcha.isLoaded && recaptchaType === "score") await fetchRecaptchaTokenAndSubmitContinue(emailWithDefault);
        };
        handleMount();
    // We only want this to run when the component mounts or
    // when recaptcha.isLoaded becomes true (if it was false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recaptcha.isLoaded
    ]);
    const onEmailClick = (0, $91i6m.useCallback)(()=>{
        setPassword("");
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const handleSubmit = async (e)=>{
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === "";
        const passwordEmpty = password === "";
        const validationErrors = {};
        e.preventDefault();
        if (isLoading) return;
        if (emailEmpty) {
            var _inputRef_current;
            validationErrors.email = formatMessage((0, $85UJE.default).emailEmpty);
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
        }
        setButtonClicked("submit");
        if (!isSecondStep) {
            analyticsClient.buttonClickedEvent(pageId, "continueToLogin");
            if (!emailEmpty) {
                if (isCheckUsernameRecaptchaEnabled) await fetchRecaptchaTokenAndSubmitContinue(trimmedEmail);
                else onContinue(trimmedEmail, null);
            }
        } else {
            analyticsClient.buttonClickedEvent(pageId, "login");
            if (passwordEmpty) validationErrors.password = formatMessage((0, $85UJE.default).passwordEmpty);
            else if (!emailEmpty) onLogIn(trimmedEmail, password, captchaValue, marketingConsent);
        }
        if (Object.keys(validationErrors).length) {
            analyticsClient.errorShownEvent((0, $6nFQr.loginPageId), "validationError");
            onValidationError(validationErrors);
        }
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked("passwordless");
        onPasswordlessLogIn(trimmedEmail, captchaValue);
    };
    const handleCaptchaChange = (0, $91i6m.useCallback)((captchaValue)=>{
        setCaptchaValue(captchaValue);
    }, []);
    const handleMarketingConsentChange = (0, $91i6m.useCallback)((consent)=>{
        setMarketingConsent(consent);
    }, []);
    const handlePasswordChange = (0, $91i6m.useCallback)((e)=>{
        setPassword(e.currentTarget.value);
    }, []);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const incorrectCredentialsErrorMessage = ()=>{
        if (nextAttempt > 4) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.error.invalid.credentials.more.help.xml",
            defaultMessage: "We've recently made changes to the login page. If you are having difficulty logging in, <reset-password-link>reset your password</reset-password-link>.",
            values: {
                "reset-password-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("a", {
                        href: resetPasswordLink
                    }, chunks)
            }
        });
        else if (application === "trello") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.error.invalid.credentials.trello.specific.help.xml",
            defaultMessage: "Incorrect email address and / or password. If you recently migrated your Trello account to an Atlassian account, you will need to use your Atlassian account password. Alternatively, you can get help <reset-password-link>logging in</reset-password-link>.",
            values: {
                "reset-password-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("a", {
                        href: resetPasswordLink
                    }, chunks)
            }
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.error.invalid.credentials.xml",
            defaultMessage: "Incorrect email address and / or password.{br}Do you need help <reset-password-link>logging in</reset-password-link>?",
            values: {
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("br", null),
                "reset-password-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("a", {
                        href: resetPasswordLink
                    }, chunks)
            }
        });
    };
    const passwordLeakedErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.error.password.leaked.xml",
            defaultMessage: "You must <reset-password-link>change your password</reset-password-link> to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. <password-leaked-link>Learn more</password-leaked-link>",
            values: {
                "reset-password-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("a", {
                        href: resetPasswordLink
                    }, chunks),
                "password-leaked-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("a", {
                        href: (0, $bE8z6.PASSWORD_LEAKED_LINK)
                    }, chunks)
            }
        });
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $fYxRW.applications)[application].name : "Product";
        const testId = "login-info-test-id";
        if (info) switch(info.code){
            case "migratingExistingUser":
                {
                    const summary = formatMessage((0, $85UJE.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            case "existingUserSignupAttempt":
                {
                    const summary = formatMessage((0, $85UJE.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lnbpL.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true
                }, " ");
        }
    };
    const errorContent = ()=>{
        if (error) switch(error.code){
            case "captcha":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.captcha",
                    defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
                });
            case "captchaScoreTooLow":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.captcha.score_too_low",
                    defaultMessage: "We'd like to make sure it's really you. Please confirm you're not a robot.",
                    description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
                });
            case "invalid_user_password":
                return incorrectCredentialsErrorMessage();
            case "ambiguous_user":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.details.ambiguous",
                    defaultMessage: "It seems that you have multiple accounts associated with your email. Please contact your administrator to remove the duplicate."
                });
            case "no_email_on_remote_user":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.remote.user.no.email",
                    defaultMessage: "Your {username} user doesn't have an associated email address, so we can't create your Atlassian account. Please contact support.",
                    values: error && error.args
                });
            case "bitbucket_username_is_not_email":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.remote.user.using.username",
                    defaultMessage: "You can no longer log in with a username. Use your primary email address {username} instead.",
                    values: error.args || {}
                });
            case "username_is_not_email":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.email.not.username",
                    defaultMessage: "You must use your email address to log in. Did you mean to use {username}?",
                    values: error.args || {}
                });
            case "bitbucket_email_is_not_primary":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.remote.user.using.alias",
                    defaultMessage: "You can no longer log in with an email alias. Use your primary email address {username} instead.",
                    values: error.args || {}
                });
            case "bitbucket_mfa_enforced":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.user.mfa.enforced",
                    defaultMessage: "Your organization wants you to secure your account by setting up two-step verification.",
                    values: error.args || {}
                });
            case "bitbucket_mfa_required":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.user.mfa.required",
                    defaultMessage: "For added security, your organization wants you to log in with two-step verification.",
                    values: error.args || {}
                });
            case "bitbucket_saml_user":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.saml.user",
                    defaultMessage: "For added security, your organization wants you to log in with single sign-on.",
                    values: error.args || {}
                });
            case "email_is_not_primary":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.email.not.username",
                    defaultMessage: "You must use your email address to log in. Did you mean to use {username}?",
                    values: error.args || {}
                });
            case "too_many_logins":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.too.many.logins",
                    defaultMessage: "For security purposes, we've temporarily locked your account due to multiple log in attempts within a short period of time. Please try again in a few minutes. If this issue persists, please contact Atlassian Support."
                });
            case "multiple_google_accounts":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.google.auth.contact.support",
                    defaultMessage: "We've encountered problems signing you in with your Google Account. Please contact support to resolve this problem."
                });
            case "unable_to_verify_google_token":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.unable.to.verify.google.token",
                    defaultMessage: "We were unable to verify your Google Account. Please try again later."
                });
            case "google_email_change_not_allowed_by_auth_policy":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.google.email.change.not.allowed.by.auth.policy",
                    defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with an email address that matches your account."
                });
            case "google_email_change_not_allowed_by_user_managed_status":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.google.email.change.not.allowed.by.user.managed.status",
                    defaultMessage: "We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way."
                });
            case "social_login_missing_email":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.missing.email",
                    defaultMessage: `We did not receive a valid email address from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "social_login_missing_email_verified":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.missing.email.verified",
                    defaultMessage: `We did not receive a valid email verification from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "social_login_unexpected_login_type":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.unexpected.login.type",
                    defaultMessage: `We did not receive valid information from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "social_login_missing_slack_email_date_verified":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.slack.missing.email.date.verified",
                    defaultMessage: `We did not receive a valid email date verified from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "social_login_invalid_social_id":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.invalid.social.id",
                    defaultMessage: `We did not receive valid id from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "slack_login_invalid_team_id":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.slack.invalid.team.id",
                    defaultMessage: `We did not receive valid team id from your identity provider. Please try logging in again by typing your email address. If you don't have a password, use the "Can't log in" link to set one.`
                });
            case "social_login_managed_user":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.managed.user",
                    defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
                });
            case "social_login_requires_password_change":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.requires.password.change",
                    defaultMessage: "Your current password has expired, so you need to reset your password to continue."
                });
            case "social_login_hide_email_change_not_allowed_to_bypass_policy":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.hide.email.change.not.allowed.to.bypass.policy",
                    defaultMessage: "Sorry, you cannot hide your email once you are part of an organization. Please ensure that you share your real email."
                });
            case "social_login_email_change_not_allowed_to_bypass_policy":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.email.change.not.allowed.to.bypass.policy",
                    defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with a email address that matches your account."
                });
            case "social_login_email_change_not_allowed":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.email.change.not.allowed",
                    defaultMessage: "We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way."
                });
            case "social_login_consent_required":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.login.consent.required",
                    defaultMessage: "Please grant access to your account details if you wish to login to your Atlassian account."
                });
            case "user_is_blocked":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.user.blocked",
                    defaultMessage: "This account has been deactivated. Please contact your organization admin."
                });
            case "social_login_banned":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.social.login.banned",
                    defaultMessage: "Your admin has blocked third-party login. Log in with your email address instead."
                });
            case "apple_login_disabled":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.apple.login.disabled",
                    defaultMessage: "Sorry, it is not possible to log in with Apple at this time. We are working on it."
                });
            case "microsoft_login_disabled":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.microsoft.login.disabled",
                    defaultMessage: "Sorry, it is not possible to log in with Microsoft at this time. We are working on it."
                });
            case "slack_login_disabled":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.slack.login.disabled",
                    defaultMessage: "Sorry, it is not possible to log in with Slack at this time. We are working on it."
                });
            case "password_leaked":
                return passwordLeakedErrorMessage();
            case "login.form.token.expired":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.token.expired",
                    defaultMessage: "Your login request has expired."
                });
            case "login.form.problem.encountered":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.problem.encountered",
                    defaultMessage: "We've encountered a problem. Please try again in a few minutes."
                });
            case "login.form.email.does.not.match.loggedin.user":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.form.email.does.not.match.loggedin.user",
                    defaultMessage: "You're currently logged in as {username}, logging in as another user will log you out of your current session.",
                    values: error.args || {}
                });
            case "hosted_domain_mismatch":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "google.hosted.domain.mismatch",
                    defaultMessage: "Unable to log in with Google. Contact your admin to check your account is configured correctly or try to log in a different way."
                });
            case "switch.session.expired":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "session.switch.error.expired",
                    defaultMessage: "Your account session expired. Log in again to continue."
                });
            case "request_error":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "network.request.error",
                    defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
                });
            case "invalid.session.token":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "invalid.session.token",
                    defaultMessage: "Your session token is invalid. Log in again to continue."
                });
            case "verify.email.expired":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "verify.email.expired",
                    defaultMessage: "Your email verification attempt has expired. Enter your email address and try again."
                });
            case "verify.email.error":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "verify.email.error",
                    defaultMessage: "Something went wrong while verifying your email address. Enter your email address and try again."
                });
            case "too_many_username_requests":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "check.username.rate.limit.exceeded",
                    defaultMessage: "Too many login attempts detected. Please wait for a few minutes before trying again."
                });
            case "generic-consent-error":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "generic-consent-error",
                    defaultMessage: "Something went wrong while attempting to validate your request."
                });
            case "consent-validation-error":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "consent-validation-error",
                    defaultMessage: "Something went wrong while attempting to validate your consent. Try logging in again later."
                });
            case "consent-loading-error":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "consent-loading-error",
                    defaultMessage: "Something went wrong while loading the consent screen. Try logging in again later."
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
                    id: "login.error.unknown",
                    defaultMessage: "Something went wrong while attempting to validate your credentials."
                });
        }
    };
    (0, $91i6m.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent("viewLoginPage");
    }, [
        analyticsClient
    ]);
    const prevIsCaptchaRequired = (0, $buHgC.usePrevious)(isCaptchaRequired);
    (0, $91i6m.useEffect)(()=>{
        if (prevIsCaptchaRequired && !isCaptchaRequired) setCaptchaValue(null);
    }, [
        isCaptchaRequired,
        prevIsCaptchaRequired
    ]);
    const emailError = ()=>{
        const error = fieldErrors.email;
        switch(error){
            case "unknown":
                return intl.formatMessage((0, $85UJE.default).unexpectedErrorHappened);
            case "rate_limit_exceeded_message":
                return intl.formatMessage((0, $85UJE.default).rateLimitErrorMessage);
            default:
                return error;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($5222838829b1b3e4$export$d55ce944e082b58f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
            id: "login.form.opening.sso",
            defaultMessage: "Opening your single sign-on provider"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9OWP7.default), null));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cLysE.default), {
            appearance: "primary",
            id: "login-submit",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isCaptchaRequired && !captchaValue,
            isLoading: buttonClicked === "submit" && (!!isRedirecting || isLoading || isCheckUsernameCaptchaLoading)
        }, buttonContent());
    };
    const shouldRenderCheckUsernameRecaptcha = isCheckUsernameRecaptchaEnabled && !isSecondStep && recaptcha.enabled && recaptcha.component;
    const shouldRenderV2Recaptcha = isSecondStep && isCaptchaRequired;
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", null, isErrorShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $31nHY.default), null, errorContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", null, " ", infoContent(), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($5222838829b1b3e4$export$a7fed597f4b8afd8, {
        id: "form-login",
        "data-testid": "form-login",
        onSubmit: handleSubmit,
        onClick: onFormClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($5222838829b1b3e4$var$InputsWrapper, null, restrictedEmail || redirectType === (0, $gtKO2.CheckUserNameRedirectType).Sso ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lkawQ.default), {
        value: email
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $dmC2D.default), {
        isReadOnly: isSecondStep || isLoading,
        fieldError: emailError(),
        onChange: onEmailChange,
        value: email,
        onEmailClick: onEmailClick,
        placeholderOverride: formatMessage((0, $85UJE.default).emailPlaceholder),
        inputRef: inputRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9w0eB.default), {
        isHidden: !isSecondStep,
        fieldError: fieldErrors.password,
        onChange: handlePasswordChange,
        value: password,
        className: `field-group password-field ${isSecondStep ? "expanded" : "hidden"}`
    }), isCaptchaEnabledByConfig && (shouldRenderCheckUsernameRecaptcha ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $g6OTd.default), null, recaptcha.component) : shouldRenderV2Recaptcha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $g6OTd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $lPSLn.default), {
        sitekey: recaptchaEnterpriseCheckboxKeySite,
        onChange: handleCaptchaChange
    }))), isSecondStep && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($5222838829b1b3e4$var$StyledMarketingConsent, {
        config: marketingConsentConfig,
        onConsentChange: handleMarketingConsentChange
    })), renderExperimentButtons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gFwNN.default), {
        isHidden: !isSecondStep || !isPasswordlessAllowed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $j7UeI.StyledSocialLoginButton), {
        id: "passwordless-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bt1Sd))), {
            label: "email"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
            style: {
                width: 24
            }
        }),
        isFullWidth: true,
        advisoryEnabled: false,
        onClick: handlePasswordlessButtonClick,
        isLoading: buttonClicked === "passwordless" && (!!isRedirecting || isLoading),
        isDisabled: isCaptchaRequired && !captchaValue || isLoading || isRedirecting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
        id: "login.form.passwordless.button",
        defaultMessage: "Log in with email"
    })))));
};
var $5222838829b1b3e4$export$2e2bcd8739ae039 = $5222838829b1b3e4$export$1f58f750f20f344b;

});
parcelRequire.register("lPSLn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc84cd0c6943b5c6$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $8hJHo = parcelRequire("8hJHo");
const $bc84cd0c6943b5c6$export$c8e68dd3bf26af81 = /*#__PURE__*/ (0, $91i6m.forwardRef)((props, ref)=>{
    const { grecaptcha: grecaptcha, onChange: onChange, onErrored: onErrored, onExpired: onExpired, size: size, sitekey: sitekey } = props;
    const enterprise = grecaptcha === null || grecaptcha === void 0 ? void 0 : grecaptcha.enterprise;
    const [widgetId, setWidgetId] = (0, $91i6m.useState)();
    const containerRef = (0, $91i6m.useRef)(null);
    /**
   * The execution callbacks and states (hasRequest, resetRequired) etc.
   * are being tracked in a useRef since we don't want to react to its changes
   * but need to track it in-between renders.
   */ const executionRef = (0, $91i6m.useRef)({
        hasRequested: false,
        resetRequired: false
    });
    const resetExecutionHandlers = (0, $91i6m.useCallback)(()=>{
        delete executionRef.current.onResolve;
        delete executionRef.current.onReject;
    }, []);
    const reset = (0, $91i6m.useCallback)(()=>{
        if (enterprise && typeof widgetId === "number") enterprise.reset(widgetId);
    }, [
        enterprise,
        widgetId
    ]);
    const handleError = (0, $91i6m.useCallback)(()=>{
        var _executionRef_current;
        if (onErrored) onErrored();
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
            executionRef.current.onReject();
            resetExecutionHandlers();
        }
    }, [
        onErrored,
        resetExecutionHandlers
    ]);
    const handleChange = (0, $91i6m.useCallback)((token)=>{
        var _executionRef_current;
        if (onChange) onChange(token);
        if (!token) handleError();
        else if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onResolve) {
            executionRef.current.onResolve(token);
            resetExecutionHandlers();
        }
    }, [
        handleError,
        onChange,
        resetExecutionHandlers
    ]);
    const handleExpired = (0, $91i6m.useCallback)(()=>{
        if (onExpired) {
            var _executionRef_current;
            onExpired();
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
                executionRef.current.onReject();
                resetExecutionHandlers();
            }
        } else handleChange(null);
    }, [
        handleChange,
        onExpired,
        resetExecutionHandlers
    ]);
    const execute = (0, $91i6m.useCallback)((targetWidgetId)=>{
        const id = typeof targetWidgetId === "undefined" ? widgetId : targetWidgetId;
        if (enterprise && id !== undefined) {
            var _executionRef_current;
            // Tokens are cached, reset is needed after first execute
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.resetRequired) reset();
            executionRef.current.resetRequired = true;
            enterprise.execute(id);
        } else executionRef.current.hasRequested = true;
    }, [
        enterprise,
        reset,
        widgetId
    ]);
    const renderExplicit = (0, $91i6m.useCallback)(()=>{
        var _executionRef_current;
        if (!sitekey) {
            console.warn("ReCAPTCHAEnterprise: recaptcha enterprise site key not provided");
            return;
        }
        // Check if grecaptcha is available and if it hasn't been rendered already
        if (!(enterprise === null || enterprise === void 0 ? void 0 : enterprise.render) || widgetId !== undefined) return;
        const wrapper = document.createElement("div");
        const id = enterprise.render(wrapper, {
            sitekey: sitekey,
            size: size,
            callback: handleChange,
            "expired-callback": handleExpired,
            "error-callback": handleError
        });
        setWidgetId(id);
        containerRef.current.appendChild(wrapper);
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.hasRequested) {
            executionRef.current.hasRequested = false;
            execute(id);
        }
    }, [
        execute,
        enterprise,
        handleChange,
        handleError,
        handleExpired,
        sitekey,
        size,
        widgetId
    ]);
    (0, $91i6m.useEffect)(()=>{
        /**
     * This has to run on every render, hence why there is no dependency array.
     * renderExplicit was called on componentDidMount & componentDidUpdate when it was a class component.
     */ renderExplicit();
    });
    (0, $91i6m.useEffect)(()=>{
        const delayOfCaptchaIframeRemoving = ()=>{
            var _containerRef_current;
            const temporaryNode = document.createElement("div");
            document.body.appendChild(temporaryNode);
            temporaryNode.style.display = "none";
            // move of the recaptcha to a temporary node
            while((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.firstChild)temporaryNode.appendChild(containerRef.current.firstChild);
            // delete the temporary node after reset will be done
            setTimeout(()=>document.body.removeChild(temporaryNode), 5000);
        };
        return ()=>{
            if (widgetId !== undefined) {
                delayOfCaptchaIframeRemoving();
                reset();
            }
        };
    }, [
        reset,
        widgetId
    ]);
    (0, $91i6m.useImperativeHandle)(ref, ()=>({
            executeAsync () {
                return new Promise((resolve, reject)=>{
                    executionRef.current.onResolve = resolve;
                    executionRef.current.onReject = reject;
                    execute();
                });
            }
        }), [
        execute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", {
        "data-testid": "ReCAPTCHAEnterprise",
        ref: containerRef
    });
});
var $bc84cd0c6943b5c6$export$2e2bcd8739ae039 = (0, $8hJHo.default)(()=>"https://www.recaptcha.net/recaptcha/enterprise.js?onload=onloadcallback&render=explicit", {
    callbackName: "onloadcallback",
    globalName: "grecaptcha"
})($bc84cd0c6943b5c6$export$c8e68dd3bf26af81);

});

parcelRequire.register("bt1Sd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8593db29877e5ae9$var$_react = $8593db29877e5ae9$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $8593db29877e5ae9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8593db29877e5ae9$var$EmailIcon = (props)=>/*#__PURE__*/ $8593db29877e5ae9$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$8593db29877e5ae9$var$EmailIcon.displayName = "EmailIcon";
var $8593db29877e5ae9$var$_default = $8593db29877e5ae9$var$EmailIcon;
module.exports.default = $8593db29877e5ae9$var$_default;

});

parcelRequire.register("gFwNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1439af55d1343b8c$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");

var $6e88g = parcelRequire("6e88g");
let $1439af55d1343b8c$var$_ = (t)=>t, $1439af55d1343b8c$var$t;
const $1439af55d1343b8c$var$FieldGroupStyled = (0, $89bua.default).div($1439af55d1343b8c$var$t || ($1439af55d1343b8c$var$t = $1439af55d1343b8c$var$_`
  margin-top: ${0}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${0}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`), (0, $6e88g.gridSize)(), -(0, $6e88g.gridSize)());
function $1439af55d1343b8c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($1439af55d1343b8c$var$FieldGroupStyled, {
        ...props,
        className: `${props.className ? props.className : ""} ${props.isHidden ? "hidden" : ""}`
    });
}

});

parcelRequire.register("dmC2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37bcfc7af5918f1$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");

var $aiPk3 = parcelRequire("aiPk3");

var $h89s9 = parcelRequire("h89s9");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");

var $8tnYQ = parcelRequire("8tnYQ");

var $26Riy = parcelRequire("26Riy");

var $gaHKK = parcelRequire("gaHKK");

var $leG06 = parcelRequire("leG06");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
let $a37bcfc7af5918f1$var$_ = (t)=>t, $a37bcfc7af5918f1$var$t, $a37bcfc7af5918f1$var$t1, $a37bcfc7af5918f1$var$t2, $a37bcfc7af5918f1$var$t3;
// Offset FieldGroup negative margin by adding a top margin here.
const $a37bcfc7af5918f1$var$ReadOnlyEmail = (0, $89bua.default).div($a37bcfc7af5918f1$var$t1 || ($a37bcfc7af5918f1$var$t1 = $a37bcfc7af5918f1$var$_`
  margin-top: ${0}px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 5px;
  box-sizing: border-box;
  cursor: pointer;
  height: 39px;
  outline: none;
  padding: 9px 32px 9px 8px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  &:hover {
    background: ${0};
    border-color: ${0};
  }
  &:focus {
    border-color: ${0};
    border-width: 2px;
    padding: 8px 31px 8px 7px;
  }

  ${0}
`), (0, $6e88g.gridSize)(), (0, $kLNLK).N10, (0, $kLNLK).N20, (0, $kLNLK).B100, (0, $26Riy.media).handheld($a37bcfc7af5918f1$var$t || ($a37bcfc7af5918f1$var$t = $a37bcfc7af5918f1$var$_`
    font-size: 16px;
  `)));
const $a37bcfc7af5918f1$var$ReadOnlyEmailText = (0, $89bua.default).span($a37bcfc7af5918f1$var$t2 || ($a37bcfc7af5918f1$var$t2 = $a37bcfc7af5918f1$var$_`
  display: flex;
  overflow: hidden;
  white-space: nowrap;
`));
const $a37bcfc7af5918f1$var$StyledFieldIconContainer = (0, $89bua.default)((0, $8tnYQ.default))($a37bcfc7af5918f1$var$t3 || ($a37bcfc7af5918f1$var$t3 = $a37bcfc7af5918f1$var$_`
  float: right;
  margin-top: -22px;
  margin-right: -27px;
`));
const $a37bcfc7af5918f1$var$EmailContainer = ({ fieldError: fieldError, isReadOnly: isReadOnly, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const prevIsReadOnly = (0, $buHgC.usePrevious)(isReadOnly);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isReadOnly && prevIsReadOnly) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isReadOnly,
        prevIsReadOnly
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const handleReadOnlyKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            onEmailClick();
        }
    };
    const placeholder = placeholderOverride || formatMessage((0, $gaHKK.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gFwNN.default), null, isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($a37bcfc7af5918f1$var$ReadOnlyEmail, {
        onClick: onEmailClick,
        tabIndex: 0,
        onKeyDown: handleReadOnlyKeyDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($a37bcfc7af5918f1$var$ReadOnlyEmailText, null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($a37bcfc7af5918f1$var$StyledFieldIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aiPk3))), {
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $h89s9.default), {
        id: "username",
        testId: "username" // used in pollinators
        ,
        name: "username",
        autoComplete: "username",
        type: "email",
        placeholder: placeholder,
        label: formatMessage((0, $gaHKK.default).loginFormUsernameLabel),
        autoFocus: !isReadOnly,
        isLabelHidden: true,
        onChange: handleChange,
        isInvalid: !!fieldError,
        invalidMessage: fieldError,
        value: value,
        ref: inputRef
    }));
};
var $a37bcfc7af5918f1$export$2e2bcd8739ae039 = $a37bcfc7af5918f1$var$EmailContainer;

});
parcelRequire.register("aiPk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7803655e4c5390ba$var$_react = $7803655e4c5390ba$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $7803655e4c5390ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7803655e4c5390ba$var$EditFilledIcon = (props)=>/*#__PURE__*/ $7803655e4c5390ba$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.02 19.23a1 1 0 001.18 1.18l3.81-.78-4.21-4.21-.78 3.81zM19.844 6.707l-2.12-2.122A1.997 1.997 0 0016.308 4c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 000-2.828z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7803655e4c5390ba$var$EditFilledIcon.displayName = "EditFilledIcon";
var $7803655e4c5390ba$var$_default = $7803655e4c5390ba$var$EditFilledIcon;
module.exports.default = $7803655e4c5390ba$var$_default;

});

parcelRequire.register("h89s9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $666bf2328d96f7b9$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $7ecAu = parcelRequire("7ecAu");

var $9yEtj = parcelRequire("9yEtj");
var $iO71n = parcelRequire("iO71n");
const $666bf2328d96f7b9$var$FormTextField = ({ name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $iO71n.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $91i6m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $7ecAu.default), {
            ...fieldProps,
            ...props,
            testId: testId,
            ref: ref
        }), invalidMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9yEtj.ErrorMessage), null, invalidMessage)));
};
var $666bf2328d96f7b9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($666bf2328d96f7b9$var$FormTextField);

});
parcelRequire.register("7ecAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54339ad51eb86f63$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $61RDg = parcelRequire("61RDg");

var $dsN6L = parcelRequire("dsN6L");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $lPOF7 = parcelRequire("lPOF7");

var $koa2c = parcelRequire("koa2c");

var $4ucu0 = parcelRequire("4ucu0");
var $54339ad51eb86f63$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $54339ad51eb86f63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $54339ad51eb86f63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $54339ad51eb86f63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $54339ad51eb86f63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $54339ad51eb86f63$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "6.0.1"
};
var $54339ad51eb86f63$var$Textfield = /*#__PURE__*/ (0, $91i6m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(props, $54339ad51eb86f63$var$_excluded);
    var inputRef = (0, $91i6m.useRef)(null);
    var handleOnFocus = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnBlur = (0, $koa2c.usePlatformLeafEventHandler)($54339ad51eb86f63$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $54339ad51eb86f63$var$analyticsParams));
    var handleOnMouseDown = (0, $91i6m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $91i6m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($61RDg)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $91i6m.useMemo)(function() {
        return (0, $4ucu0.containerStyles)(appearance, width);
    }, [
        appearance,
        width
    ]);
    var inputStyle = (0, $4ucu0.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $lPOF7.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $lPOF7.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
$54339ad51eb86f63$var$Textfield.displayName = "Textfield";
var /**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ $54339ad51eb86f63$export$2e2bcd8739ae039 // The above generic is used to let ERTC know what props to extract.
 // See: https://github.com/atlassian/extract-react-types/issues/201
 = /*#__PURE__*/ (0, $91i6m.memo)($54339ad51eb86f63$var$Textfield);

});
parcelRequire.register("4ucu0", function(module, exports) {

$parcel$export(module.exports, "containerStyles", function () { return $3443a59df996b78f$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $3443a59df996b78f$export$3eeb47dc8e6249d9; });

var $dsN6L = parcelRequire("dsN6L");

var $f1k1y = parcelRequire("f1k1y");

var $kLNLK = parcelRequire("kLNLK");

var $6e88g = parcelRequire("6e88g");
function $3443a59df996b78f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3443a59df996b78f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3443a59df996b78f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3443a59df996b78f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3443a59df996b78f$var$fontSize = (0, $6e88g.fontSize)();
var $3443a59df996b78f$var$gridSize = (0, $6e88g.gridSize)();
var $3443a59df996b78f$var$backgroundColor = {
    standard: "var(--ds-background-input, ".concat((0, $kLNLK.N10), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorFocus = {
    standard: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    subtle: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$backgroundColorHover = {
    standard: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    subtle: "var(--ds-background-input-hovered, ".concat((0, $kLNLK.N30), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColor = {
    standard: "var(--ds-border-input, ".concat((0, $f1k1y.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $kLNLK.N100) : (0, $kLNLK.N40), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorFocus = {
    standard: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    subtle: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
    none: "transparent"
};
var $3443a59df996b78f$var$borderColorHover = {
    standard: "var(--ds-border-input, ".concat((0, $f1k1y.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $kLNLK.N100) : (0, $kLNLK.N40), ")"),
    subtle: "var(--ds-border-input, transparent)",
    none: "transparent"
};
var $3443a59df996b78f$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance) {
    return {
        backgroundColor: $3443a59df996b78f$var$backgroundColor[appearance],
        borderColor: $3443a59df996b78f$var$borderColor[appearance],
        color: "var(--ds-text, ".concat((0, $kLNLK.N900), ")"),
        cursor: "text",
        "&:hover:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorHover[appearance],
            borderColor: $3443a59df996b78f$var$borderColorHover[appearance]
        },
        "&:focus-within:not([data-disabled])": {
            backgroundColor: $3443a59df996b78f$var$backgroundColorFocus[appearance],
            borderColor: $3443a59df996b78f$var$borderColorFocus[appearance],
            boxShadow: (0, $f1k1y.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $3443a59df996b78f$var$borderColorFocus[appearance]) : undefined
        },
        "&[data-disabled]": $3443a59df996b78f$var$_objectSpread({
            color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")"),
            cursor: "not-allowed"
        }, appearance === "standard" && {
            backgroundColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")"),
            borderColor: "var(--ds-background-disabled, ".concat((0, $kLNLK.N10), ")")
        }),
        "&[data-invalid], &[data-invalid]:hover": {
            borderColor: "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")"),
            boxShadow: (0, $f1k1y.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $kLNLK.R400), ")")) : undefined
        },
        "&[data-invalid]:focus-within": {
            backgroundColor: "var(--ds-background-input-pressed, ".concat((0, $kLNLK.N0), ")"),
            borderColor: "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")"),
            boxShadow: (0, $f1k1y.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $kLNLK.B200), ")")) : undefined
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[data-invalid]:focus-within": {
                borderColor: "Highlight"
            },
            "&:focus-within": {
                borderColor: "Highlight"
            },
            "&[data-disabled]": {
                borderColor: "GrayText"
            }
        }
    };
};
var $3443a59df996b78f$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $3443a59df996b78f$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $3443a59df996b78f$var$widthMap ? $3443a59df996b78f$var$widthMap[width] : +width;
};
var $3443a59df996b78f$export$5972a68b6e54f38f = function containerStyles(appearance, width) {
    return $3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread($3443a59df996b78f$var$_objectSpread({
        alignItems: "center"
    }, $3443a59df996b78f$var$getContainerTextBgAndBorderColor(appearance)), {}, {
        borderRadius: 3,
        borderWidth: (0, $f1k1y.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "var(--ds-border-width, 1px)" : 2
    }, (0, $f1k1y.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") && appearance !== "none" ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === "none" ? "none" : "solid",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 1 100%",
        fontSize: $3443a59df996b78f$var$fontSize,
        justifyContent: "space-between",
        maxWidth: $3443a59df996b78f$var$getMaxWidth(width),
        overflow: "hidden",
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: "break-word",
        verticalAlign: "top",
        pointerEvents: "auto"
    });
};
var $3443a59df996b78f$export$3eeb47dc8e6249d9 = function inputStyles() {
    return {
        backgroundColor: "transparent",
        border: 0,
        boxSizing: "border-box",
        color: "inherit",
        cursor: "inherit",
        fontSize: $3443a59df996b78f$var$fontSize,
        minWidth: "0",
        outline: "none",
        width: "100%",
        lineHeight: $3443a59df996b78f$var$gridSize * 2.5 / $3443a59df996b78f$var$fontSize,
        fontFamily: (0, $6e88g.fontFamily)(),
        "&[data-monospaced]": {
            fontFamily: (0, $6e88g.codeFontFamily)()
        },
        "&[data-compact]": {
            padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($3443a59df996b78f$var$gridSize * 3.5 / $3443a59df996b78f$var$fontSize).toFixed(2), "em")
        },
        "&:not([data-compact])": {
            padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($3443a59df996b78f$var$gridSize * 4.5 / $3443a59df996b78f$var$fontSize).toFixed(2), "em")
        },
        "&[disabled]": {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
        },
        // Hide the clear indicator on Edge (Windows only)
        "&::-ms-clear": {
            display: "none"
        },
        "&:invalid": {
            boxShadow: "none"
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        },
        "&::placeholder": {
            color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.N200), ")"),
            "&:disabled": {
                color: "var(--ds-text-disabled, ".concat((0, $kLNLK.N70), ")")
            }
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[disabled]": {
                color: "GrayText"
            }
        }
    };
};

});



parcelRequire.register("8tnYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42aa2300f6a2cb0c$export$2e2bcd8739ae039; });

var $89bua = parcelRequire("89bua");

var $kLNLK = parcelRequire("kLNLK");
let $42aa2300f6a2cb0c$var$_ = (t)=>t, $42aa2300f6a2cb0c$var$t;
const $42aa2300f6a2cb0c$var$iconSize = "24px";
var $42aa2300f6a2cb0c$export$2e2bcd8739ae039 = (0, $89bua.default).span($42aa2300f6a2cb0c$var$t || ($42aa2300f6a2cb0c$var$t = $42aa2300f6a2cb0c$var$_`
  color: ${0};
  height: ${0};
  width: ${0};

  + div input {
    margin-right: ${0};
  }
`), (0, $kLNLK).N500, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize, $42aa2300f6a2cb0c$var$iconSize);

});

parcelRequire.register("gaHKK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb38136af8a7975$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $dcb38136af8a7975$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: "login.form.username.placeholder",
        defaultMessage: "Enter email"
    },
    loginFormUsernameLabel: {
        id: "login.form.username.label",
        defaultMessage: "Email"
    }
});

});

parcelRequire.register("0wXBc", function(module, exports) {
$parcel$export(module.exports, "useForceRedirect", function () { return (parcelRequire("kBhWP")).useForceRedirect; });
$parcel$export(module.exports, "useOnMount", function () { return (parcelRequire("ilSAr")).useOnMount; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("buHgC")).usePrevious; });
$parcel$export(module.exports, "useGoogleLoginHandler", function () { return (parcelRequire("5k5vC")).useGoogleLoginHandler; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return (parcelRequire("5k5vC")).useSocialLoginHandlers; });
$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return (parcelRequire("iiGfm")).useRecaptchaChallengeObserver; });
parcelRequire("kBhWP");
parcelRequire("ilSAr");
parcelRequire("buHgC");
parcelRequire("5k5vC");
parcelRequire("iiGfm");

});
parcelRequire.register("kBhWP", function(module, exports) {

$parcel$export(module.exports, "useForceRedirect", function () { return $b61d37644088eedf$export$20eacf679bc57a60; });

var $91i6m = parcelRequire("91i6m");
const $b61d37644088eedf$export$20eacf679bc57a60 = ({ redirectTo: redirectTo })=>{
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo) try {
            const url = new URL(redirectTo);
            window.location.assign(url);
        } catch (e) {
        // invalid URL provided
        }
    }, [
        redirectTo
    ]);
};

});

parcelRequire.register("ilSAr", function(module, exports) {

$parcel$export(module.exports, "useOnMount", function () { return $a79f15c75a3c2974$export$820558710db2d9c6; });

var $91i6m = parcelRequire("91i6m");
const $a79f15c75a3c2974$export$820558710db2d9c6 = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $91i6m.useEffect)(()=>callback(), []);
};

});

parcelRequire.register("buHgC", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $8a47e052c4eb17f1$export$5cae361ad82dce8b; });

var $91i6m = parcelRequire("91i6m");
function $8a47e052c4eb17f1$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});

parcelRequire.register("5k5vC", function(module, exports) {

$parcel$export(module.exports, "useGoogleLoginHandler", function () { return $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return $73f38aab5cb7ff9b$export$3388df9a8c5125bf; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $ccxRw = parcelRequire("ccxRw");
const $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2 = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(pageId, "googleLoginButton", {
            redirectType: redirectType
        });
        (0, $ccxRw.redirectToGoogleLogin)(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
};
const $73f38aab5cb7ff9b$export$3388df9a8c5125bf = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const handleSocialLogin = (0, $91i6m.useCallback)((redirectFn, buttonId)=>{
        analyticsClient.buttonClickedEvent(pageId, buttonId, {
            redirectType: redirectType
        });
        redirectFn(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToMicrosoftLogin), "microsoftLoginButton"), [
        handleSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToAppleLogin), "appleLoginButton"), [
        handleSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToSlackLogin), "slackLoginButton"), [
        handleSocialLogin
    ]);
    return {
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});

parcelRequire.register("iiGfm", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return $e5421413c7fac630$export$4cc6b1f2fa5dc3f4; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");
const $e5421413c7fac630$var$recaptchaIframeTitle = "recaptcha challenge";
const $e5421413c7fac630$export$4cc6b1f2fa5dc3f4 = (pageId)=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const bodyObserver = (0, $91i6m.useRef)();
    const attributeObserver = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        /*
      To determine if user has been presented with a Google reCAPTCHA challenge, we need to listen to DOM events and check if an <iframe> was injected.
      Said <iframe> will have 'src' attribute containing 'google.com/recaptcha/api2/bframe'. Unfortunately, that is not enough
      because Google will inject the <iframe> even if they're not gonna show the challenge. So we attach another observer,
      looking for a change on the 'style' attribute of the outmost containing <div>. If style.target.visibility is 'visible',
      then we send analytics event.
    */ const outerContainerAttributeObserver = ()=>{
            return new MutationObserver((records)=>{
                const visibleEvent = Array.from(records).find((mutation)=>mutation.attributeName === "style" && mutation.target.style.visibility === "visible");
                if (visibleEvent) {
                    var _attributeObserver_current;
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: "challenge",
                        subject: "googleRecaptcha"
                    });
                    (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
                }
            });
        };
        if (window.MutationObserver) {
            var _bodyObserver_current;
            bodyObserver.current = new MutationObserver((records)=>{
                records.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        if (!(node instanceof Element)) return;
                        const recaptchaIframe = node.querySelector(`iframe[title*='${$e5421413c7fac630$var$recaptchaIframeTitle}']`);
                        if (recaptchaIframe) {
                            var _bodyObserver_current, _recaptchaIframe_parentNode;
                            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
                            const recaptchaOuterDiv = (_recaptchaIframe_parentNode = recaptchaIframe.parentNode) === null || _recaptchaIframe_parentNode === void 0 ? void 0 : _recaptchaIframe_parentNode.parentNode;
                            if (recaptchaOuterDiv) {
                                var _attributeObserver_current;
                                attributeObserver.current = outerContainerAttributeObserver();
                                (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.observe(recaptchaOuterDiv, {
                                    attributes: true
                                });
                            }
                        }
                    });
                });
            });
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.observe(window.document.body, {
                childList: true
            });
        }
        return ()=>{
            var _bodyObserver_current, _attributeObserver_current;
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
            (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
        };
    }, [
        analyticsClient,
        pageId
    ]);
};

});



parcelRequire.register("9w0eB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b319ab9a4a7a53ac$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $gFwNN = parcelRequire("gFwNN");

var $c1txK = parcelRequire("c1txK");

var $cJRdM = parcelRequire("cJRdM");

var $leG06 = parcelRequire("leG06");
parcelRequire("0wXBc");
var $buHgC = parcelRequire("buHgC");
const $b319ab9a4a7a53ac$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value })=>{
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const inputRef = (0, $91i6m.useRef)(null);
    const wasHidden = (0, $buHgC.usePrevious)(isHidden);
    (0, $91i6m.useEffect)(()=>{
        var _inputRef_current;
        if (!isHidden && wasHidden) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("span", {
        id: "password-error"
    }, fieldError) : fieldError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gFwNN.default), {
        isHidden: isHidden,
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $c1txK.default), {
        id: "password",
        testId: "password" // used in pollinators
        ,
        name: "password",
        autoComplete: "current-password",
        placeholder: formatMessage((0, $cJRdM.default).passwordPlaceholder),
        label: formatMessage((0, $cJRdM.default).passwordLabel),
        autoFocus: !isHidden,
        isLabelHidden: true,
        onChange: onChange,
        isInvalid: !!fieldError,
        invalidMessage: fieldErrorNode,
        value: value,
        ref: inputRef
    }));
};
var $b319ab9a4a7a53ac$export$2e2bcd8739ae039 = $b319ab9a4a7a53ac$var$PasswordContainer;

});
parcelRequire.register("c1txK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d35d6bdef48785fd$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $h89s9 = parcelRequire("h89s9");

var $89bua = parcelRequire("89bua");

var $6yJnE = parcelRequire("6yJnE");

var $gB4dU = parcelRequire("gB4dU");

var $tbh94 = parcelRequire("tbh94");
let $d35d6bdef48785fd$var$_ = (t)=>t, $d35d6bdef48785fd$var$t, $d35d6bdef48785fd$var$t1;
const $d35d6bdef48785fd$export$d25f95f50a0dfdf9 = (0, $89bua.default).div($d35d6bdef48785fd$var$t || ($d35d6bdef48785fd$var$t = $d35d6bdef48785fd$var$_`
  padding-right: 2px;
`));
const $d35d6bdef48785fd$var$StyledDiv = (0, $89bua.default).div($d35d6bdef48785fd$var$t1 || ($d35d6bdef48785fd$var$t1 = $d35d6bdef48785fd$var$_`
  input {
    ${0}
`), (props)=>props.smallPlaceholder && "font-size: 14px !important;");
const $d35d6bdef48785fd$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $91i6m.useRef)(null);
    const [type, setType] = (0, $91i6m.useState)("password");
    (0, $91i6m.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        var _inputRef_current;
        setType(type === "password" ? "text" : "password");
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($d35d6bdef48785fd$var$StyledDiv, {
        smallPlaceholder: props.smallPlaceholder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $h89s9.default), {
        ...props,
        type: type,
        autoComplete: type === "password" ? props.autoComplete || "off" : "off",
        spellCheck: false,
        ref: inputRef,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($d35d6bdef48785fd$export$d25f95f50a0dfdf9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $tbh94.default), {
            appearance: "subtle",
            icon: type === "text" ? (0, (/*@__PURE__*/$parcel$interopDefault($gB4dU))) : (0, (/*@__PURE__*/$parcel$interopDefault($6yJnE))),
            label: type === "text" ? "Hide password" : "Show password",
            onClick: handleVisibilityToggle
        }))
    })));
};
var $d35d6bdef48785fd$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef($d35d6bdef48785fd$var$PasswordField);

});
parcelRequire.register("6yJnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c691eb080b990e3$var$_react = $4c691eb080b990e3$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $4c691eb080b990e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4c691eb080b990e3$var$WatchIcon = (props)=>/*#__PURE__*/ $4c691eb080b990e3$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.977 13.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4"/></g></svg>`
    }, props));
$4c691eb080b990e3$var$WatchIcon.displayName = "WatchIcon";
var $4c691eb080b990e3$var$_default = $4c691eb080b990e3$var$WatchIcon;
module.exports.default = $4c691eb080b990e3$var$_default;

});

parcelRequire.register("gB4dU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c15360b5fe5850fb$var$_react = $c15360b5fe5850fb$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $c15360b5fe5850fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c15360b5fe5850fb$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $c15360b5fe5850fb$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 01-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 014.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$c15360b5fe5850fb$var$WatchFilledIcon.displayName = "WatchFilledIcon";
var $c15360b5fe5850fb$var$_default = $c15360b5fe5850fb$var$WatchFilledIcon;
module.exports.default = $c15360b5fe5850fb$var$_default;

});

parcelRequire.register("tbh94", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057b74a26f2e932f$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $91i6m = parcelRequire("91i6m");

var $8nwgg = parcelRequire("8nwgg");

var $hbHfz = parcelRequire("hbHfz");
var $057b74a26f2e932f$var$_excluded = [
    "analyticsContext",
    "interactionName",
    "autoFocus",
    "appearance",
    "spacing",
    "isDisabled",
    "isSelected",
    "icon",
    "label",
    "overlay",
    "onClick",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onTouchStartCapture",
    "onTouchEndCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onClickCapture",
    "shape",
    "type",
    "testId",
    "UNSAFE_size",
    "aria-label"
];
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $057b74a26f2e932f$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, interactionName = _ref.interactionName, autoFocus = _ref.autoFocus, appearance = _ref.appearance, spacing = _ref.spacing, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, icon = _ref.icon, label = _ref.label, overlay = _ref.overlay, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, shape = _ref.shape, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, UNSAFE_size = _ref.UNSAFE_size, preventedAriaLabel = _ref["aria-label"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref, $057b74a26f2e932f$var$_excluded);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $hbHfz.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8nwgg.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$057b74a26f2e932f$var$IconButton.displayName = "IconButton";
var $057b74a26f2e932f$export$2e2bcd8739ae039 = $057b74a26f2e932f$var$IconButton;

});
parcelRequire.register("hbHfz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8350358a3b7f001$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $kQU6o = parcelRequire("kQU6o");

var $fXpPO = parcelRequire("fXpPO");

var $6U7Fi = parcelRequire("6U7Fi");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $c8350358a3b7f001$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay);
    var isCircle = shape === "circle";
    var baseProps = (0, $6U7Fi.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $fXpPO.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
            label: "",
            size: UNSAFE_size
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $kQU6o.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $c8350358a3b7f001$export$2e2bcd8739ae039 = $c8350358a3b7f001$var$useIconButton;

});



parcelRequire.register("cJRdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $92a8e4c7e4d2e5c9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    passwordPlaceholder: {
        id: "login.form.password.placeholder",
        defaultMessage: "Enter password"
    },
    passwordLabel: {
        id: "login.form.password.label",
        defaultMessage: "Password"
    }
});

});


parcelRequire.register("lkawQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eecdbb3e8b3e970b$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");

var $6e88g = parcelRequire("6e88g");

var $gFwNN = parcelRequire("gFwNN");
let $eecdbb3e8b3e970b$var$_ = (t)=>t, $eecdbb3e8b3e970b$var$t;
const $eecdbb3e8b3e970b$export$fbbb54563138a84f = (0, $89bua.default).div($eecdbb3e8b3e970b$var$t || ($eecdbb3e8b3e970b$var$t = $eecdbb3e8b3e970b$var$_`
  box-sizing: border-box;
  height: 39px;
  overflow: hidden;
  padding: 10px 9px;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Offset FieldGroup negative margin. */
  margin-top: ${0}px;
`), (0, $6e88g.gridSize)());
const $eecdbb3e8b3e970b$var$RestrictedEmailContainer = ({ value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $gFwNN.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($eecdbb3e8b3e970b$export$fbbb54563138a84f, {
        title: value
    }, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("input", {
        "data-testid": "restricted-email-container",
        autoComplete: "username",
        type: "hidden",
        name: "username",
        value: value
    }));
};
var $eecdbb3e8b3e970b$export$2e2bcd8739ae039 = $eecdbb3e8b3e970b$var$RestrictedEmailContainer;

});

parcelRequire.register("g6OTd", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNotice", function () { return $6101c3d22ae535b7$export$4faf58f44fb24e61; });
$parcel$export(module.exports, "default", function () { return $6101c3d22ae535b7$export$2e2bcd8739ae039; });

var $89bua = parcelRequire("89bua");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $6T9dz = parcelRequire("6T9dz");

var $91i6m = parcelRequire("91i6m");

var $k8ZoM = parcelRequire("k8ZoM");
let $6101c3d22ae535b7$var$_ = (t)=>t, $6101c3d22ae535b7$var$t, $6101c3d22ae535b7$var$t1;
const $6101c3d22ae535b7$var$ReCaptchaContainer = (0, $89bua.default).div($6101c3d22ae535b7$var$t || ($6101c3d22ae535b7$var$t = $6101c3d22ae535b7$var$_`
  margin-top: ${0}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`), (0, $6e88g.gridSize)());
const $6101c3d22ae535b7$var$PolicyLink = (0, $89bua.default).a($6101c3d22ae535b7$var$t1 || ($6101c3d22ae535b7$var$t1 = $6101c3d22ae535b7$var$_`
  color: ${0};

  &:hover {
    color: ${0};
  }
`), (0, $k8ZoM.default)("color.link", (0, $kLNLK).B400), (0, $k8ZoM.default)("color.link", (0, $kLNLK).B400));
const $6101c3d22ae535b7$export$4faf58f44fb24e61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
        id: "signup.form.recaptcha.notice.xml",
        defaultMessage: "This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply.",
        values: {
            "google-pp-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6101c3d22ae535b7$var$PolicyLink, {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noreferrer noopener"
                }, chunks),
            "google-tos-link": (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6101c3d22ae535b7$var$PolicyLink, {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noreferrer noopener"
                }, chunks)
        }
    });
var $6101c3d22ae535b7$export$2e2bcd8739ae039 = $6101c3d22ae535b7$var$ReCaptchaContainer;

});

parcelRequire.register("31nHY", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $807125d1ec365411$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $807125d1ec365411$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $807125d1ec365411$export$1142f7f46d50535e; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");

var $6e88g = parcelRequire("6e88g");

var $8iEgn = parcelRequire("8iEgn");
let $807125d1ec365411$var$_ = (t)=>t, $807125d1ec365411$var$t, $807125d1ec365411$var$t1;
const $807125d1ec365411$export$21ea266f0fa7d7c3 = (0, $89bua.default).div($807125d1ec365411$var$t || ($807125d1ec365411$var$t = $807125d1ec365411$var$_`
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 2);
const $807125d1ec365411$var$SectionErrorWrapper = (0, $89bua.default).div($807125d1ec365411$var$t1 || ($807125d1ec365411$var$t1 = $807125d1ec365411$var$_`
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, $6e88g.gridSize)(), (0, $6e88g.gridSize)());
function $807125d1ec365411$export$2e2bcd8739ae039({ testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($807125d1ec365411$export$21ea266f0fa7d7c3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iEgn.default), {
        testId: testId || "form-error",
        appearance: "warning",
        title: title
    }, children)) : null;
}
function $807125d1ec365411$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($807125d1ec365411$var$SectionErrorWrapper, {
        id: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iEgn.default), {
        testId: testId || "form-error",
        appearance: "warning",
        title: title
    }, children)) : null;
}

});
parcelRequire.register("8iEgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60af3c968af4b9f4$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $4rdPx = parcelRequire("4rdPx");

var $eaJyx = parcelRequire("eaJyx");

var $9X0U9 = parcelRequire("9X0U9");
var $TJrLs = parcelRequire("TJrLs");
var $ijE2m = parcelRequire("ijE2m");
var $lBrex = parcelRequire("lBrex");

var $1fll9 = parcelRequire("1fll9");
var $60af3c968af4b9f4$var$sectionMessageStyles = (0, $lBrex.xcss)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $60af3c968af4b9f4$var$bleedStyles = (0, $lBrex.xcss)({
    display: "flex",
    marginBlock: "var(--ds-space-negative-025, -2px)"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $60af3c968af4b9f4$var$SectionMessage = /*#__PURE__*/ (0, $91i6m.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $1fll9.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        as: "section",
        backgroundColor: $60af3c968af4b9f4$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $60af3c968af4b9f4$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        xcss: $60af3c968af4b9f4$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ijE2m.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $eaJyx.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4rdPx.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
var $60af3c968af4b9f4$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$60af3c968af4b9f4$var$SectionMessage.displayName = "SectionMessage";
var $60af3c968af4b9f4$export$2e2bcd8739ae039 = $60af3c968af4b9f4$var$SectionMessage;

});
parcelRequire.register("eaJyx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a51556551e3d5884$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $lPOF7 = parcelRequire("lPOF7");

var $kKFpx = parcelRequire("kKFpx");

var $4jXgk = parcelRequire("4jXgk");

var $e08gr = parcelRequire("e08gr");
var $a51556551e3d5884$var$_excluded = [
    "level",
    "variant"
];
// https://atlassian.design/foundations/typography
var $a51556551e3d5884$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $a51556551e3d5884$var$headingResetStyles = (0, $lPOF7.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $a51556551e3d5884$var$h900Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $a51556551e3d5884$var$h800Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $a51556551e3d5884$var$h700Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $a51556551e3d5884$var$h600Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $a51556551e3d5884$var$h500Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $a51556551e3d5884$var$h400Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a51556551e3d5884$var$h300Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $a51556551e3d5884$var$h200Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a51556551e3d5884$var$h100Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a51556551e3d5884$var$inverseStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $a51556551e3d5884$var$subtlestStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $a51556551e3d5884$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $e08gr;
    var _useHeading = (0, $kKFpx.useHeading)($a51556551e3d5884$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $lPOF7.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $a51556551e3d5884$var$headingResetStyles,
            level === "h100" && $a51556551e3d5884$var$h100Styles,
            level === "h200" && $a51556551e3d5884$var$h200Styles,
            level === "h300" && $a51556551e3d5884$var$h300Styles,
            level === "h400" && $a51556551e3d5884$var$h400Styles,
            level === "h500" && $a51556551e3d5884$var$h500Styles,
            level === "h600" && $a51556551e3d5884$var$h600Styles,
            level === "h700" && $a51556551e3d5884$var$h700Styles,
            level === "h800" && $a51556551e3d5884$var$h800Styles,
            level === "h900" && $a51556551e3d5884$var$h900Styles,
            color === "inverse" && $a51556551e3d5884$var$inverseStyles,
            color === "default" && isSubtleHeading && $a51556551e3d5884$var$subtlestStyles
        ]
    }, children);
};
var $a51556551e3d5884$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, variant = _ref2.variant, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $a51556551e3d5884$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $lPOF7.jsx)($a51556551e3d5884$var$Heading, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $lPOF7.jsx)((0, $4jXgk.default), (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        variant: variant
    }, props));
};

});
parcelRequire.register("kKFpx", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $03e611732ccf8cfe$export$97a37b1befbbf9b1; });

var $91i6m = parcelRequire("91i6m");
// Allows support for heading levels 1-9 via aria-level
var $03e611732ccf8cfe$var$HeadingLevelContext = /*#__PURE__*/ (0, $91i6m.createContext)(0);
var $03e611732ccf8cfe$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $91i6m.useContext)($03e611732ccf8cfe$var$HeadingLevelContext);
};
var $03e611732ccf8cfe$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $03e611732ccf8cfe$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $03e611732ccf8cfe$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $03e611732ccf8cfe$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($03e611732ccf8cfe$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $03e611732ccf8cfe$export$2e2bcd8739ae039 = $03e611732ccf8cfe$var$HeadingLevelContextProvider;

});

parcelRequire.register("4jXgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3256e80d983535fa$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $lPOF7 = parcelRequire("lPOF7");

var $kKFpx = parcelRequire("kKFpx");

var $e08gr = parcelRequire("e08gr");
// https://atlassian.design/foundations/typography
var $3256e80d983535fa$var$variantTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $3256e80d983535fa$var$headingResetStyles = (0, $lPOF7.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $3256e80d983535fa$var$inverseStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading variant="xxlarge">Page title</Heading>
 * ```
 */ var $3256e80d983535fa$var$Heading = function Heading(_ref) {
    var children = _ref.children, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $e08gr;
    // Technically variant can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since variant will be a required prop.
    var _useHeading = (0, $kKFpx.useHeading)($3256e80d983535fa$var$variantTagMap[variant]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    return (0, $lPOF7.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $3256e80d983535fa$var$headingResetStyles,
            variant && $3256e80d983535fa$var$headingVariantStylesMap[variant],
            color === "inverse" && $3256e80d983535fa$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c4d235cbada3951edcb53e36bd07b2b>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $3256e80d983535fa$var$headingVariantStylesMap = {
    xxlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $3256e80d983535fa$export$2e2bcd8739ae039 = $3256e80d983535fa$var$Heading;

});


parcelRequire.register("1fll9", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $0e87bee448892c08$export$e9b82d2e21ac0c1f; });

var $dsN6L = parcelRequire("dsN6L");

var $1pjMo = parcelRequire("1pjMo");

var $daZRO = parcelRequire("daZRO");

var $1a5r2 = parcelRequire("1a5r2");

var $kjPIx = parcelRequire("kjPIx");

var $cOOAJ = parcelRequire("cOOAJ");

var $kLNLK = parcelRequire("kLNLK");
function $0e87bee448892c08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e87bee448892c08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e87bee448892c08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e87bee448892c08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e87bee448892c08$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $kLNLK.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1a5r2))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $kLNLK.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $kLNLK.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $kLNLK.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $kLNLK.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($daZRO))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $kLNLK.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $kLNLK.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pjMo))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $kLNLK.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $kLNLK.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kjPIx))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $kLNLK.P500), ")")
    }
};
function $0e87bee448892c08$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $0e87bee448892c08$export$faa35441caff5bb6[appearance] || $0e87bee448892c08$export$faa35441caff5bb6.information;
    var Icon = icon || appearanceIconStyles.Icon;
    return $0e87bee448892c08$var$_objectSpread($0e87bee448892c08$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRequire.register("1a5r2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d8af0efc0b94215$var$_react = $0d8af0efc0b94215$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $0d8af0efc0b94215$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0d8af0efc0b94215$var$InfoIcon = (props)=>/*#__PURE__*/ $0d8af0efc0b94215$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$0d8af0efc0b94215$var$InfoIcon.displayName = "InfoIcon";
var $0d8af0efc0b94215$var$_default = $0d8af0efc0b94215$var$InfoIcon;
module.exports.default = $0d8af0efc0b94215$var$_default;

});

parcelRequire.register("kjPIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03d140d28e37bc44$var$_react = $03d140d28e37bc44$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $03d140d28e37bc44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $03d140d28e37bc44$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $03d140d28e37bc44$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$03d140d28e37bc44$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $03d140d28e37bc44$var$_default = $03d140d28e37bc44$var$QuestionCircleIcon;
module.exports.default = $03d140d28e37bc44$var$_default;

});

parcelRequire.register("cOOAJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $955165eea80d5a75$var$_react = $955165eea80d5a75$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $955165eea80d5a75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $955165eea80d5a75$var$WarningIcon = (props)=>/*#__PURE__*/ $955165eea80d5a75$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$955165eea80d5a75$var$WarningIcon.displayName = "WarningIcon";
var $955165eea80d5a75$var$_default = $955165eea80d5a75$var$WarningIcon;
module.exports.default = $955165eea80d5a75$var$_default;

});




parcelRequire.register("lnbpL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c71a1682cc4a680$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $89bua = parcelRequire("89bua");

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");
let $5c71a1682cc4a680$var$_ = (t)=>t, $5c71a1682cc4a680$var$t;
const $5c71a1682cc4a680$var$FormInfo = (0, $89bua.default).div($5c71a1682cc4a680$var$t || ($5c71a1682cc4a680$var$t = $5c71a1682cc4a680$var$_`
  color: ${0};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${0}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`), (0, $kLNLK).N700, (0, $6e88g.gridSize)() * 2);
const $5c71a1682cc4a680$var$FormInfoComponent = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($5c71a1682cc4a680$var$FormInfo, {
        role: "alert",
        ...props,
        className: props.isHidden ? "hidden" : ""
    }, children);
};
var $5c71a1682cc4a680$export$2e2bcd8739ae039 = $5c71a1682cc4a680$var$FormInfoComponent;

});

parcelRequire.register("j7UeI", function(module, exports) {

$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $6b71b168e012af76$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $6b71b168e012af76$export$2e2bcd8739ae039; });

var $kLNLK = parcelRequire("kLNLK");
var $6e88g = parcelRequire("6e88g");

var $91i6m = parcelRequire("91i6m");

var $leG06 = parcelRequire("leG06");

var $89bua = parcelRequire("89bua");

var $5Ip6i = parcelRequire("5Ip6i");

var $lxrnE = parcelRequire("lxrnE");

var $bvEP4 = parcelRequire("bvEP4");

var $76SzD = parcelRequire("76SzD");

var $ccxRw = parcelRequire("ccxRw");

var $ySUvx = parcelRequire("ySUvx");

var $cLysE = parcelRequire("cLysE");

var $8iEgn = parcelRequire("8iEgn");

var $cOOAJ = parcelRequire("cOOAJ");

var $9MKJ7 = parcelRequire("9MKJ7");

var $6d87w = parcelRequire("6d87w");
let $6b71b168e012af76$var$_ = (t)=>t, $6b71b168e012af76$var$t, $6b71b168e012af76$var$t1, $6b71b168e012af76$var$t2, $6b71b168e012af76$var$t3;
const $6b71b168e012af76$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const location = (0, $6d87w.useLocation)();
    const { formatMessage: formatMessage } = (0, $leG06.default)();
    const microsoftEnabled = (0, $ccxRw.isMicrosoftAuthEnabled)(location);
    const appleEnabled = (0, $ccxRw.isAppleAuthEnabled)(location);
    const slackEnabled = (0, $ccxRw.isSlackAuthEnabled)(location);
    const googleOutageEnabled = (0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)();
    const microsoftOutageEnabled = (0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)();
    const appleOutageEnabled = (0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)();
    const slackOutageEnabled = (0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)();
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $ySUvx.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $8iEgn.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("p", null, sectionMessageDescription));
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageTitle) : formatMessage((0, $ySUvx.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $ySUvx.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $ySUvx.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $ySUvx.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $ySUvx.default).slackOutageDescription) : formatMessage((0, $ySUvx.default).someOutageDescription);
    const GoogleButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButton, {
            id: "google-auth-button",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($lxrnE))),
            onClick: handleGoogleLogin,
            advisoryEnabled: googleOutageEnabled,
            outageTooltipMessage: formatMessage((0, $ySUvx.default).googleOutageDescription)
        }, "Google"));
    };
    const MicrosoftButton = ()=>{
        return microsoftEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButton, {
            id: "microsoft-auth-button",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bvEP4))),
            onClick: handleMicrosoftLogin,
            advisoryEnabled: microsoftOutageEnabled,
            outageTooltipMessage: formatMessage((0, $ySUvx.default).microsoftOutageDescription)
        }, "Microsoft"));
    };
    const AppleButton = ()=>{
        return appleEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButton, {
            id: "apple-auth-button",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5Ip6i))),
            onClick: handleAppleLogin,
            advisoryEnabled: appleOutageEnabled,
            outageTooltipMessage: formatMessage((0, $ySUvx.default).appleOutageDescription)
        }, "Apple"));
    };
    const SlackButton = ()=>{
        return slackEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButton, {
            id: "slack-auth-button",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($76SzD))),
            onClick: handleSlackLogin,
            advisoryEnabled: slackOutageEnabled,
            outageTooltipMessage: formatMessage((0, $ySUvx.default).slackOutageDescription)
        }, "Slack"));
    };
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
            "data-testid": "social-login-button-row"
        }, GoogleButton(), MicrosoftButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$var$SocialLoginButtonRowGroup, {
            "data-testid": "social-login-button-row"
        }, AppleButton(), SlackButton()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$export$e61ba37bbdbb1966, {
        "data-i18n-or": formatMessage((0, $ySUvx.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $ySUvx.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper"
    }, showButtonsGridLayout(), isSocialLoginOutage && getAdvisorySectionMessage());
};
const $6b71b168e012af76$export$e61ba37bbdbb1966 = (0, $89bua.default).div($6b71b168e012af76$var$t || ($6b71b168e012af76$var$t = $6b71b168e012af76$var$_`
  margin-top: ${0}px;

  &::before {
    color: ${0};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${0}px;
    font-weight: 600;
    text-align: center;
  }
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK).N300, (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButtonRowGroup = (0, $89bua.default).div($6b71b168e012af76$var$t1 || ($6b71b168e012af76$var$t1 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginOptionWrapper = (0, $89bua.default).div($6b71b168e012af76$var$t2 || ($6b71b168e012af76$var$t2 = $6b71b168e012af76$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $6e88g.gridSize)() * 2);
const $6b71b168e012af76$var$SocialLoginButton = ({ children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage, ...props })=>{
    const commonProps = {
        isFullWidth: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement("img", {
            src: logo,
            alt: ""
        })
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9MKJ7.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$export$27110045cf7ea8db, {
        advisoryEnabled: true,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))), {
            testId: "social-auth-button-warning-icon",
            label: "",
            primaryColor: (0, $kLNLK).Y500,
            secondaryColor: (0, $kLNLK).Y50
        }),
        ...commonProps,
        ...props
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($6b71b168e012af76$export$27110045cf7ea8db, {
        advisoryEnabled: false,
        ...commonProps,
        ...props
    }, children);
};
const $6b71b168e012af76$export$27110045cf7ea8db = (0, $89bua.default)((0, $cLysE.default), {
    shouldForwardProp: (propName)=>![
            "advisoryEnabled"
        ].includes(propName)
})($6b71b168e012af76$var$t3 || ($6b71b168e012af76$var$t3 = $6b71b168e012af76$var$_`
  background: ${0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${0};
  border-radius: 3px;
  color: ${0};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${0}px;
  }

  &:hover {
    background: ${0} !important;
  }
  &:active {
    background: ${0} !important;
    color: ${0} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`), (props)=>props.advisoryEnabled ? (0, $kLNLK).Y50 : (0, $kLNLK).N0, (0, $kLNLK).N50, (0, $kLNLK).N800, (0, $6e88g.gridSize)() * 0.5, (0, $kLNLK).N10A, (0, $kLNLK).N20A, (0, $kLNLK).N400);
var $6b71b168e012af76$export$2e2bcd8739ae039 = $6b71b168e012af76$export$969af4902a13348e;

});
parcelRequire.register("5Ip6i", function(module, exports) {

module.exports = new URL((parcelRequire("lxKym")).resolve("84TCq"), import.meta.url).toString();

});

parcelRequire.register("lxrnE", function(module, exports) {

module.exports = new URL((parcelRequire("lxKym")).resolve("hQgRT"), import.meta.url).toString();

});

parcelRequire.register("bvEP4", function(module, exports) {

module.exports = new URL((parcelRequire("lxKym")).resolve("faAYQ"), import.meta.url).toString();

});

parcelRequire.register("76SzD", function(module, exports) {

module.exports = new URL((parcelRequire("lxKym")).resolve("6eAR3"), import.meta.url).toString();

});

parcelRequire.register("ySUvx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e74db0f439e21255$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $e74db0f439e21255$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    socialAuthContinue: {
        id: "social.auth.continue",
        defaultMessage: "Or continue with",
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: "some.outage.title",
        defaultMessage: "Issues with some login options",
        description: "Message to the user that there are currently issues logging in with some providers due to an outage"
    },
    googleOutageTitle: {
        id: "google.outage.title",
        defaultMessage: "Issues with Google login",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageTitle: {
        id: "microsoft.outage.title",
        defaultMessage: "Issues with Microsoft login",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageTitle: {
        id: "apple.outage.title",
        defaultMessage: "Issues with Apple login",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageTitle: {
        id: "slack.outage.title",
        defaultMessage: "Issues with Slack login",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    },
    someOutageDescription: {
        id: "some.outage.description",
        defaultMessage: "Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.",
        description: "Message to the user that there are currently issues logging in with due to a login provider outage"
    },
    googleOutageDescription: {
        id: "google.outage.description",
        defaultMessage: "There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Google due to an outage"
    },
    microsoftOutageDescription: {
        id: "microsoft.outage.description",
        defaultMessage: "There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Microsoft due to an outage"
    },
    appleOutageDescription: {
        id: "apple.outage.description",
        defaultMessage: "There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Apple due to an outage"
    },
    slackOutageDescription: {
        id: "slack.outage.description",
        defaultMessage: "There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.",
        description: "Message to the user that there are currently issues logging in with Slack due to an outage"
    }
});

});


parcelRequire.register("85UJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4259b3ec55034ef5$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $4259b3ec55034ef5$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    unexpectedErrorHappened: {
        id: "login.form.sso.check.unknown.error",
        defaultMessage: "Unexpected error happened.",
        description: ""
    },
    emailPlaceholder: {
        id: "login.form.email.placeholder",
        defaultMessage: "Enter your email"
    },
    emailEmpty: {
        id: "login.form.email.empty",
        defaultMessage: "Enter an email address"
    },
    passwordEmpty: {
        id: "login.form.password.empty",
        defaultMessage: "Enter your password"
    },
    migrateAccountInfo: {
        id: "login.form.info.migrate.account",
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: "Login form info container message"
    },
    existingUserSignupAttemptInfo: {
        id: "login.form.info.existing.user.signup.attempt",
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: "Login form info container message for existing user signup attempt"
    },
    rateLimitErrorMessage: {
        id: "login.form.email.rate-limit-exceeded.error",
        defaultMessage: "There have been too many attempts to reverify your account in the past hour. Please try again later.",
        description: "Telling the user that they have exceeded welcome email limit"
    }
});

});

parcelRequire.register("3yDip", function(module, exports) {

$parcel$export(module.exports, "recaptchaCheckUsernameFetchTokenInteraction", function () { return $04c86f329a8264d4$export$b7874a5a14992cfe; });

var $iBu0H = parcelRequire("iBu0H");
const $04c86f329a8264d4$export$b7874a5a14992cfe = (0, $iBu0H.metrics).interaction({
    key: "aid-frontend-recaptcha-fetch-token-check-username"
});

});


parcelRequire.register("gKURT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4108e007ab21b5b$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $6T9dz = parcelRequire("6T9dz");

var $89bua = parcelRequire("89bua");

var $6e88g = parcelRequire("6e88g");

var $kLNLK = parcelRequire("kLNLK");

var $cLysE = parcelRequire("cLysE");

var $7cVVr = parcelRequire("7cVVr");

var $lxrnE = parcelRequire("lxrnE");

var $bvEP4 = parcelRequire("bvEP4");

var $5Ip6i = parcelRequire("5Ip6i");

var $76SzD = parcelRequire("76SzD");

var $gtKO2 = parcelRequire("gtKO2");
let $c4108e007ab21b5b$var$_ = (t)=>t, $c4108e007ab21b5b$var$t, $c4108e007ab21b5b$var$t1, $c4108e007ab21b5b$var$t2, $c4108e007ab21b5b$var$t3;
const $c4108e007ab21b5b$var$SocialLoginBlock = (0, $89bua.default).div($c4108e007ab21b5b$var$t || ($c4108e007ab21b5b$var$t = $c4108e007ab21b5b$var$_`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${0}px;

  border: 1px solid ${0};
  border-radius: 3px;
`), (0, $6e88g.gridSize)() * 1.5, (0, $kLNLK.N50));
const $c4108e007ab21b5b$var$Header = (0, $89bua.default).div($c4108e007ab21b5b$var$t1 || ($c4108e007ab21b5b$var$t1 = $c4108e007ab21b5b$var$_`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${0}px;
`), (0, $6e88g.gridSize)() * 1.5);
const $c4108e007ab21b5b$var$Email = (0, $89bua.default).div($c4108e007ab21b5b$var$t2 || ($c4108e007ab21b5b$var$t2 = $c4108e007ab21b5b$var$_`
  font-weight: 600;
  font-size: 14px;
  line-height: ${0}px;
  color: ${0};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $6e88g.gridSize)() * 3, (0, $kLNLK.N800));
const $c4108e007ab21b5b$var$Logo = (0, $89bua.default).img($c4108e007ab21b5b$var$t3 || ($c4108e007ab21b5b$var$t3 = $c4108e007ab21b5b$var$_`
  height: ${0}px;
  padding-right: ${0}px;
`), (0, $6e88g.gridSize)() * 3, (0, $6e88g.gridSize)());
const $c4108e007ab21b5b$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lxrnE));
        case (0, $gtKO2.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bvEP4));
        case (0, $gtKO2.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5Ip6i));
        case (0, $gtKO2.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($76SzD));
    }
};
const $c4108e007ab21b5b$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $gtKO2.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $gtKO2.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $gtKO2.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $gtKO2.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $c4108e007ab21b5b$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $c4108e007ab21b5b$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c4108e007ab21b5b$var$SocialLoginBlock, {
        "data-testid": "social-login-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c4108e007ab21b5b$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c4108e007ab21b5b$var$Logo, {
        src: $c4108e007ab21b5b$var$getLogo(highlightedSocialProvider),
        alt: `${highlightedSocialProvider} logo`
    }), email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($c4108e007ab21b5b$var$Email, null, email)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $cLysE.default), {
        isFullWidth: true,
        id: "social-login-submit",
        appearance: "primary",
        onClick: handleSocialLogin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $6T9dz.default), {
        ...(0, $7cVVr.default).continueWith,
        values: {
            socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
        }
    })));
};
var $c4108e007ab21b5b$export$2e2bcd8739ae039 = $c4108e007ab21b5b$var$SocialLoginForm;

});
parcelRequire.register("7cVVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70b522f9e02cef9$export$2e2bcd8739ae039; });

var $j5RJC = parcelRequire("j5RJC");
var $b70b522f9e02cef9$export$2e2bcd8739ae039 = (0, $j5RJC.defineMessages)({
    continueWith: {
        id: "social.login.form.continue-button",
        defaultMessage: "Continue with {socialProviderName}",
        description: "Button label that is a CTA for users to continue logging in using the selected social provider."
    }
});

});


parcelRequire.register("7JGKf", function(module, exports) {

$parcel$export(module.exports, "getSocialLoginEligibility", function () { return $fea9e4b105970f8f$export$e8b4b1bf168dca09; });

var $gtKO2 = parcelRequire("gtKO2");

var $ccxRw = parcelRequire("ccxRw");
const $fea9e4b105970f8f$export$98889b02384daf87 = [
    (0, $gtKO2.SocialProvider).Google,
    (0, $gtKO2.SocialProvider).Microsoft,
    (0, $gtKO2.SocialProvider).Apple,
    (0, $gtKO2.SocialProvider).Slack
];
const $fea9e4b105970f8f$var$socialProviderToHighPriorityPredicate = {
    [(0, $gtKO2.SocialProvider).Google]: ()=>!(0, $ccxRw.isGoogleLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Microsoft]: ()=>!(0, $ccxRw.isMicrosoftLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Apple]: ()=>!(0, $ccxRw.isAppleLoginOutageAdvisoryEnabled)(),
    [(0, $gtKO2.SocialProvider).Slack]: ()=>!(0, $ccxRw.isSlackLoginOutageAdvisoryEnabled)()
};
const $fea9e4b105970f8f$export$94af6b531db26586 = ()=>{
    const highPriority = [];
    const lowPriority = [];
    $fea9e4b105970f8f$export$98889b02384daf87.forEach((provider)=>{
        const isHighPriority = $fea9e4b105970f8f$var$socialProviderToHighPriorityPredicate[provider];
        if (isHighPriority && !isHighPriority()) lowPriority.push(provider);
        else // No predicate means no definition of low priority, so it must be high priority.
        highPriority.push(provider);
    });
    return highPriority.concat(lowPriority);
};
const $fea9e4b105970f8f$export$47bb6da133b3804e = (connected, enabled)=>{
    const rankedSocialProviders = $fea9e4b105970f8f$export$94af6b531db26586();
    for (const socialProvider of rankedSocialProviders){
        if (connected.includes(socialProvider) && enabled.includes(socialProvider)) return socialProvider;
    }
    return null;
};
const $fea9e4b105970f8f$export$e5abae2d758ca82f = (identities)=>{
    if (!identities) return [];
    return Object.values((0, $gtKO2.SocialProvider)).filter((provider)=>{
        return !!(identities === null || identities === void 0 ? void 0 : identities[provider]);
    });
};
const $fea9e4b105970f8f$export$34b87b0d5d6ea34f = (location)=>{
    const enabledSocialButtons = [
        (0, $gtKO2.SocialProvider).Google
    ];
    if ((0, $ccxRw.isMicrosoftAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Microsoft);
    if ((0, $ccxRw.isAppleAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Apple);
    if ((0, $ccxRw.isSlackAuthEnabled)(location)) enabledSocialButtons.push((0, $gtKO2.SocialProvider).Slack);
    return enabledSocialButtons;
};
const $fea9e4b105970f8f$export$55a908504dbef32d = (socialProvider, application, hasPassword = true)=>Boolean(socialProvider && !hasPassword && application !== "trello");
const $fea9e4b105970f8f$export$e8b4b1bf168dca09 = (identities, location, application)=>{
    const connectedSocialProviders = $fea9e4b105970f8f$export$e5abae2d758ca82f(identities);
    const enabledSocialButtons = $fea9e4b105970f8f$export$34b87b0d5d6ea34f(location);
    const highlightedSocialProvider = $fea9e4b105970f8f$export$47bb6da133b3804e(connectedSocialProviders, enabledSocialButtons);
    const hasPassword = identities === null || identities === void 0 ? void 0 : identities.password;
    const isEligibleForSocialLogin = $fea9e4b105970f8f$export$55a908504dbef32d(highlightedSocialProvider, application, hasPassword);
    return {
        isEligibleForSocialLogin: isEligibleForSocialLogin,
        highlightedSocialProvider: highlightedSocialProvider,
        connectedSocialProviders: connectedSocialProviders,
        enabledSocialButtons: enabledSocialButtons,
        firstProductAccessed: application || "unknown",
        hasPassword: hasPassword
    };
};

});

parcelRequire.register("90cOu", function(module, exports) {

$parcel$export(module.exports, "LoginPageMessages", function () { return $98b9b8b5ed854730$export$81a860015c7169ad; });

var $j5RJC = parcelRequire("j5RJC");
const $98b9b8b5ed854730$export$81a860015c7169ad = (0, $j5RJC.defineMessages)({
    headTitle: {
        id: "login.head.title",
        defaultMessage: "Log in to continue"
    },
    contextualTitle: {
        id: "login.contextual.title",
        defaultMessage: "Continue to",
        description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`
    },
    socialAuthOr: {
        id: "social.auth.or",
        defaultMessage: "or"
    },
    socialAuthOrContinueWith: {
        id: "social.auth.or-continue-with",
        defaultMessage: "Or continue with:"
    },
    createAnAccount: {
        id: "login.create.an.account",
        defaultMessage: "Create an account"
    },
    passwordlessSuccessTitle: {
        id: "login.passwordless.success.title",
        defaultMessage: "Email sent"
    },
    passwordlessSuccessDescription: {
        id: "login.passwordless.success.description",
        defaultMessage: "We've sent you an email to log in."
    },
    socialFormHeader: {
        id: "login.social.form.header",
        defaultMessage: "Log in",
        description: "Subtle header shown on the social login form which allows users to login with the chosen social provider"
    },
    socialFormTitle: {
        id: "login.social.form.title",
        defaultMessage: "You logged in with your {socialProviderName} account before",
        description: "Title shown on the social login form which allows users to login with the chosen social provider"
    },
    socialFormUseDifferentLoginMethod: {
        id: "login.social.form.use-different-login-method",
        defaultMessage: "Use a different login method",
        description: "Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form."
    },
    continueAs: {
        id: "continue.as.title.as",
        defaultMessage: "Continue as",
        description: "This is a page title that will be followed by an avatar hero with name and email"
    }
});

});

parcelRequire.register("gz8Vs", function(module, exports) {

$parcel$export(module.exports, "usePageState", function () { return $c93ad68fb7998f93$export$d2bdb7c20492cc5; });

var $jvbQq = parcelRequire("jvbQq");

var $4b8M8 = parcelRequire("4b8M8");

var $bqdjD = parcelRequire("bqdjD");
const $c93ad68fb7998f93$export$d2bdb7c20492cc5 = (path)=>{
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $jvbQq.useQuery)({
        queryKey: [
            window.location.pathname
        ],
        queryFn: async ()=>{
            const response = await (0, $4b8M8.fetchApi)((0, $bqdjD.idacOrigin) + path);
            const data = await response.json();
            return data;
        }
    });
    return {
        state: data,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
};

});
parcelRequire.register("jvbQq", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $e32a19ad30175e2a$export$dd0a697e1782aedd; });

var $2Yp8D = parcelRequire("2Yp8D");
var $4aKPy = parcelRequire("4aKPy");

var $cv9WW = parcelRequire("cv9WW");
"use client";
function $e32a19ad30175e2a$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $2Yp8D.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $cv9WW.useBaseQuery)(parsedOptions, (0, $4aKPy.QueryObserver));
}

});
parcelRequire.register("4aKPy", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $309c6c256985a53f$export$a06cf8c0066f0d4c; });

var $2Yp8D = parcelRequire("2Yp8D");

var $3gH3P = parcelRequire("3gH3P");

var $gCDn7 = parcelRequire("gCDn7");

var $5si2t = parcelRequire("5si2t");

var $ljaX7 = parcelRequire("ljaX7");
class $309c6c256985a53f$export$a06cf8c0066f0d4c extends (0, $5si2t.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($309c6c256985a53f$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $309c6c256985a53f$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $309c6c256985a53f$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $2Yp8D.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $309c6c256985a53f$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($309c6c256985a53f$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $2Yp8D.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $2Yp8D.isServer) || this.currentResult.isStale || !(0, $2Yp8D.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $2Yp8D.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $2Yp8D.isServer) || this.options.enabled === false || !(0, $2Yp8D.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $gCDn7.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $309c6c256985a53f$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $309c6c256985a53f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $ljaX7.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $2Yp8D.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $2Yp8D.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $309c6c256985a53f$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $2Yp8D.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $ljaX7.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $3gH3P.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $309c6c256985a53f$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $309c6c256985a53f$var$shouldFetchOnMount(query, options) {
    return $309c6c256985a53f$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $309c6c256985a53f$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $309c6c256985a53f$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $309c6c256985a53f$var$isStale(query, options);
    }
    return false;
}
function $309c6c256985a53f$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $309c6c256985a53f$var$isStale(query, options);
}
function $309c6c256985a53f$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $309c6c256985a53f$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $2Yp8D.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});

parcelRequire.register("cv9WW", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $91a01919b7eea1cb$export$fff0865807e996c5; });

var $91i6m = parcelRequire("91i6m");

var $3gH3P = parcelRequire("3gH3P");

var $iJ5WK = parcelRequire("iJ5WK");

var $cAJ4v = parcelRequire("cAJ4v");

var $ejkzJ = parcelRequire("ejkzJ");

var $j4cWE = parcelRequire("j4cWE");

var $2pWiG = parcelRequire("2pWiG");

var $3arzc = parcelRequire("3arzc");
"use client";
function $91a01919b7eea1cb$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $ejkzJ.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $j4cWE.useIsRestoring)();
    const errorResetBoundary = (0, $cAJ4v.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $3gH3P.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $3arzc.ensureStaleTime)(defaultedOptions);
    (0, $2pWiG.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2pWiG.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $91i6m.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $iJ5WK.useSyncExternalStore)($91i6m.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $3gH3P.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $91i6m.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $3arzc.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $3arzc.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2pWiG.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRequire.register("iJ5WK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $da210ad7ec1e34a0$export$306c0aa65ff9ec16; });

var $7eLHz = parcelRequire("7eLHz");
"use client";
const $da210ad7ec1e34a0$export$306c0aa65ff9ec16 = (0, $7eLHz.useSyncExternalStore);

});
parcelRequire.register("7eLHz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dkY6K"));

});
parcelRequire.register("dkY6K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $9b5bc4c8ced37df0$export$306c0aa65ff9ec16; }, function (v) { return $9b5bc4c8ced37df0$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9b5bc4c8ced37df0$export$306c0aa65ff9ec16;
"use strict";

var $91i6m = parcelRequire("91i6m");
function $9b5bc4c8ced37df0$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9b5bc4c8ced37df0$var$k = "function" === typeof Object.is ? Object.is : $9b5bc4c8ced37df0$var$h, $9b5bc4c8ced37df0$var$l = $91i6m.useState, $9b5bc4c8ced37df0$var$m = $91i6m.useEffect, $9b5bc4c8ced37df0$var$n = $91i6m.useLayoutEffect, $9b5bc4c8ced37df0$var$p = $91i6m.useDebugValue;
function $9b5bc4c8ced37df0$var$q(a, b) {
    var d = b(), f = $9b5bc4c8ced37df0$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $9b5bc4c8ced37df0$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $9b5bc4c8ced37df0$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $9b5bc4c8ced37df0$var$m(function() {
        $9b5bc4c8ced37df0$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $9b5bc4c8ced37df0$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $9b5bc4c8ced37df0$var$p(d);
    return d;
}
function $9b5bc4c8ced37df0$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$9b5bc4c8ced37df0$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $9b5bc4c8ced37df0$var$t(a, b) {
    return b();
}
var $9b5bc4c8ced37df0$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $9b5bc4c8ced37df0$var$t : $9b5bc4c8ced37df0$var$q;
$9b5bc4c8ced37df0$export$306c0aa65ff9ec16 = void 0 !== $91i6m.useSyncExternalStore ? $91i6m.useSyncExternalStore : $9b5bc4c8ced37df0$var$u;

});



parcelRequire.register("cAJ4v", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $92abcf1f5f58f625$export$50dfac555130cafd; });

var $91i6m = parcelRequire("91i6m");
"use client";
function $92abcf1f5f58f625$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $92abcf1f5f58f625$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $91i6m.createContext($92abcf1f5f58f625$var$createValue()); // HOOK
const $92abcf1f5f58f625$export$50dfac555130cafd = ()=>$91i6m.useContext($92abcf1f5f58f625$var$QueryErrorResetBoundaryContext); // COMPONENT
const $92abcf1f5f58f625$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $91i6m.useState(()=>$92abcf1f5f58f625$var$createValue());
    return /*#__PURE__*/ $91i6m.createElement($92abcf1f5f58f625$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRequire.register("j4cWE", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $de186ea63643ce3b$export$4da0178d6b5f553; });

var $91i6m = parcelRequire("91i6m");
"use client";
const $de186ea63643ce3b$var$IsRestoringContext = /*#__PURE__*/ $91i6m.createContext(false);
const $de186ea63643ce3b$export$4da0178d6b5f553 = ()=>$91i6m.useContext($de186ea63643ce3b$var$IsRestoringContext);
const $de186ea63643ce3b$export$593807d4e94f9621 = $de186ea63643ce3b$var$IsRestoringContext.Provider;

});

parcelRequire.register("2pWiG", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $1c2b23cb48e51925$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $1c2b23cb48e51925$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $1c2b23cb48e51925$export$1fbcf724762d607; });

var $91i6m = parcelRequire("91i6m");

var $faSZL = parcelRequire("faSZL");
"use client";
const $1c2b23cb48e51925$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $1c2b23cb48e51925$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $91i6m.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $1c2b23cb48e51925$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $faSZL.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRequire.register("faSZL", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $b0c273167b1efc8a$export$2072f68e6c3507cf; });
function $b0c273167b1efc8a$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRequire.register("3arzc", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $24e7b07969390e1b$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $24e7b07969390e1b$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $24e7b07969390e1b$export$defdc11a9c9acfcf; });
const $24e7b07969390e1b$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $24e7b07969390e1b$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $24e7b07969390e1b$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $24e7b07969390e1b$export$e0a3f29513afe430(result, isRestoring);
const $24e7b07969390e1b$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRequire.register("4b8M8", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $9fcd5aed9186d793$export$adb4bb4243526aef; });

var $49Pnv = parcelRequire("49Pnv");
const $9fcd5aed9186d793$export$adb4bb4243526aef = async (url)=>{
    const response = await fetch(url, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    if (!response.ok) {
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const data = await response.json();
        (0, $49Pnv.captureErrorMessage)(message, data);
        throw new Error(message);
    }
    return response;
};

});


parcelRequire.register("3uRS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e330ecfcf56a330f$export$2e2bcd8739ae039; });
const $e330ecfcf56a330f$var$EMPTY_APP_STATE_VALUE = "{{data_app_state}}";
const $e330ecfcf56a330f$var$shouldFetchStateApi = ()=>document.body.getAttribute("data-app-state") === $e330ecfcf56a330f$var$EMPTY_APP_STATE_VALUE;
var $e330ecfcf56a330f$export$2e2bcd8739ae039 = $e330ecfcf56a330f$var$shouldFetchStateApi;

});


parcelRequire.register("15GiP", function(module, exports) {

$parcel$export(module.exports, "headingSizes", function () { return $0cb7128838712e24$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $0cb7128838712e24$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $0cb7128838712e24$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $0cb7128838712e24$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $0cb7128838712e24$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $0cb7128838712e24$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $0cb7128838712e24$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $0cb7128838712e24$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $0cb7128838712e24$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $0cb7128838712e24$export$dfc0e69214efdc3c; });

var $dsN6L = parcelRequire("dsN6L");

var $kLNLK = parcelRequire("kLNLK");

var $6e88g = parcelRequire("6e88g");
function $0cb7128838712e24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0cb7128838712e24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0cb7128838712e24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0cb7128838712e24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0cb7128838712e24$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $6e88g.fontSize)(), "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $0cb7128838712e24$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $0cb7128838712e24$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h900.size, $0cb7128838712e24$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 6.5, "px")
    });
};
var $0cb7128838712e24$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h800.size, $0cb7128838712e24$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h700.size, $0cb7128838712e24$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 5, "px")
    });
};
var $0cb7128838712e24$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h600.size, $0cb7128838712e24$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3.5, "px")
    });
};
var $0cb7128838712e24$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h500.size, $0cb7128838712e24$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 3, "px")
    });
};
var $0cb7128838712e24$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h400.size, $0cb7128838712e24$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h300.size, $0cb7128838712e24$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $kLNLK.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $0cb7128838712e24$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h200.size, $0cb7128838712e24$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};
var $0cb7128838712e24$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $0cb7128838712e24$var$_objectSpread($0cb7128838712e24$var$_objectSpread({}, $0cb7128838712e24$var$baseHeading($0cb7128838712e24$export$bc02e067df412c3b.h100.size, $0cb7128838712e24$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $kLNLK.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $6e88g.gridSize)() * 2, "px")
    });
};

});

parcelRequire.register("aTAfv", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $7eeb28c052954e83$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $7eeb28c052954e83$export$bb5ca5fba6fb4f1f; });

var $91i6m = parcelRequire("91i6m");

var $kV8TC = parcelRequire("kV8TC");
var $7eeb28c052954e83$var$generateUID = function(context) {
    var quartz = context || (0, $kV8TC.counter);
    var prefix = (0, $kV8TC.getPrefix)(quartz);
    var id = (0, $kV8TC.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $7eeb28c052954e83$var$useUIDState = function() {
    // @ts-ignore
    return $91i6m.useState($7eeb28c052954e83$var$generateUID($91i6m.useContext((0, $kV8TC.source))));
};
var $7eeb28c052954e83$export$87d05f07e65211f1 = function() {
    var uid = $7eeb28c052954e83$var$useUIDState()[0].uid;
    return uid;
};
var $7eeb28c052954e83$export$bb5ca5fba6fb4f1f = function() {
    var gen = $7eeb28c052954e83$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRequire.register("kV8TC", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $f3b0081445314065$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $f3b0081445314065$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $f3b0081445314065$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $f3b0081445314065$export$36e24695f02d4503; });

var $91i6m = parcelRequire("91i6m");

var $3Bnk9 = parcelRequire("3Bnk9");
var $f3b0081445314065$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $3Bnk9.generateUID)()
    };
};
var $f3b0081445314065$export$e575061ef2a070eb = $f3b0081445314065$export$1921362e86c73c88();
var $f3b0081445314065$export$b4d5da5f34fb77ad = $91i6m.createContext($f3b0081445314065$export$1921362e86c73c88());
var $f3b0081445314065$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $f3b0081445314065$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});


parcelRequire.register("bb3nf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823356c98a5580de$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $823356c98a5580de$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});


//# sourceMappingURL=LoginPage.fa4c8995.js.map
